/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { DeleteStudentsSessionsR200ResponseFromJSON, DeleteTeachersAffiliationsR200ResponseFromJSON, GetActivityFeedForCourseR200ResponseFromJSON, GetActivityFeedForStudentR200ResponseInnerFromJSON, GetConsoleAgentR200ResponseFromJSON, GetContentAreaAdaptiveAnswersR200ResponseInnerFromJSON, GetContentAreaAdaptiveProgressesR200ResponseInnerFromJSON, GetContentAreaConstructedResponsesR200ResponseInnerFromJSON, GetContentAreaDepthOfKnowledgeQuestionSetsR200ResponseInnerFromJSON, GetContentAreaDomainTranslationR200ResponseFromJSON, GetContentAreaDomainsExclusionsR200ResponseInnerFromJSON, GetContentAreaIblsR200ResponseInnerFromJSON, GetContentAreaSkillProficienciesProgressR200ResponseFromJSON, GetContentAreaSkillProficienciesR200ResponseInnerFromJSON, GetContentAreaSkillsR200ResponseInnerFromJSON, GetContentAreaVideosR200ResponseInnerFromJSON, GetCourseElaAdaptiveSkillsAdaptiveProgressesR200ResponseInnerFromJSON, GetCourseElaAdaptiveSkillsSkillGroupsReportR200ResponseInnerFromJSON, GetCourseEnabledDashboardModesR200ResponseInnerFromJSON, GetCourseMathAssessmentsGrowthReportR200ResponseInnerFromJSON, GetCourseMathAssessmentsStandardGrowthReportR200ResponseInnerFromJSON, GetCourseMembershipsR200ResponseInnerFromJSON, GetCourseReportsElaGroupsByLevelR200ResponseInnerFromJSON, GetCourseReportsElaPerformanceByStandardR200ResponseInnerFromJSON, GetCourseSubjectProductSettingsR200ResponseFromJSON, GetCourseSubjectsR200ResponseInnerFromJSON, GetCoursesClassCodesR200ResponseFromJSON, GetCoursesClassDomainGrowthR200ResponseInnerFromJSON, GetCoursesMathDiagnosticsR200ResponseInnerFromJSON, GetCoursesMathFactPracticeLevelsR200ResponseInnerFromJSON, GetCoursesMathReportCardSummariesR200ResponseInnerFromJSON, GetCoursesR200ResponseInnerFromJSON, GetCoursesReportsMathTargetedAssignmentQuestionPerformanceR200ResponseInnerFromJSON, GetCoursesStudentStandardStatsR200ResponseInnerFromJSON, GetCoursesStudentsR200ResponseInnerFromJSON, GetCoursesUnmanagedR200ResponseInnerFromJSON, GetCoursesWordStudyLevelsLatestPerStudentR200ResponseInnerFromJSON, GetDistrictSchoolsR200ResponseInnerFromJSON, GetDistrictsR200ResponseInnerFromJSON, GetElaAdaptiveSkillsAnswersR200ResponseInnerFromJSON, GetElaAdaptiveSkillsContentsR200ResponseInnerFromJSON, GetElaAdaptiveSkillsPassagesR200ResponseInnerFromJSON, GetElaArticleReadingAnswersR200ResponseInnerFromJSON, GetElaArticleReadingAnswersRetriesR200ResponseInnerFromJSON, GetElaArticleSearchR200ResponseFromJSON, GetElaArticleWritingAnswersR200ResponseInnerFromJSON, GetElaAssessmentAssignmentAnswersR200ResponseInnerFromJSON, GetElaAssessmentAssignmentReportR200ResponseFromJSON, GetElaAssessmentSessionReportR200ResponseFromJSON, GetElaClassActivityDetailR200ResponseFromJSON, GetElaClassActivityR200ResponseInnerFromJSON, GetElaDecodablesAssignmentsR200ResponseInnerFromJSON, GetElaDecodablesHighestR200ResponseFromJSON, GetElaReadingLevelsR200ResponseInnerFromJSON, GetElaSightWordsLevelR200ResponseFromJSON, GetElaSightWordsR200ResponseInnerFromJSON, GetElaTargetedSkillsAnswersR200ResponseInnerFromJSON, GetElaTargetedSkillsPassagesR200ResponseInnerFromJSON, GetElaVocabWordsR200ResponseInnerFromJSON, GetElaWordStudySessionsProgressR200ResponseFromJSON, GetExternalDemoDistrictsR200ResponseFromJSON, GetItemsR200ResponseInnerFromJSON, GetLanguagesR200ResponseInnerFromJSON, GetLoginCardsR200ResponseInnerFromJSON, GetMathAdaptiveAssignmentSessionAnswersR200ResponseInnerFromJSON, GetMathAssessmentByIdR200ResponseFromJSON, GetMathAssessmentsAssessmentAnswersR200ResponseInnerFromJSON, GetMathAssignmentsAssignmentSessionsIsAnySessionCompleteR200ResponseFromJSON, GetMathFactPracticeSnapshotsR200ResponseInnerFromJSON, GetMathFactPracticeUsageR200ResponseFromJSON, GetMathStandardAssignmentQuestionsR200ResponseInnerFromJSON, GetMathTargetedAssignmentSessionsAnswersR200ResponseInnerFromJSON, GetNumberFactsLevelsR200ResponseInnerFromJSON, GetNumberFactsQuestionsR200ResponseFromJSON, GetOperationR200ResponseFromJSON, GetPeriscopeEmbedsSchoolUsageR200ResponseFromJSON, GetPremiumLicensesR200ResponseFromJSON, GetReferralsR200ResponseInnerFromJSON, GetRostersR200ResponseInnerFromJSON, GetSchoolAdminsMeDashboardR200ResponseFromJSON, GetSchoolAdminsMeR200ResponseFromJSON, GetSchoolAdminsMeTeachersMissingEmailsCsvR200ResponseInnerFromJSON, GetSchoolAdminsR200ResponseInnerFromJSON, GetSchoolAssessments2R200ResponseInnerFromJSON, GetSchoolColleaguesR200ResponseInnerFromJSON, GetSchoolDeletionInfoR200ResponseFromJSON, GetSchoolLicensesR200ResponseFromJSON, GetSchoolLicensesR200ResponseAnyOfInner1FromJSON, GetSchoolsR200ResponseInnerFromJSON, GetSchoolsSearchR200ResponseFromJSON, GetSelfStudentR200ResponseFromJSON, GetSelfStudentR200ResponseElaStandardSetFromJSON, GetSocialStudiesWritingAssignmentAnswersR200ResponseInnerFromJSON, GetStudentHighlightsForCourseR200ResponseFromJSON, GetStudentMathAdaptiveRewardsR200ResponseInnerFromJSON, GetStudentMathAdaptiveRewardsR200ResponseInnerRewardFromJSON, GetStudentMathAdaptiveStatsStudentDomainMonthLatestR200ResponseInnerFromJSON, GetStudentMathAdaptiveStatsStudentDomainMonthLatestR200ResponseInnerDomainFromJSON, GetStudentMathDomainStatusesR200ResponseInnerFromJSON, GetStudentMathProgressR200ResponseInnerFromJSON, GetStudentMathReportCardR200ResponseFromJSON, GetStudentStandardStatsR200ResponseInnerFromJSON, GetStudentsCoTeachersR200ResponseInnerFromJSON, GetStudentsDuplicatesR200ResponseInnerFromJSON, GetStudentsElaProgressR200ResponseFromJSON, GetStudentsElaReportCardR200ResponseFromJSON, GetStudentsElaSnapshotR200ResponseInnerFromJSON, GetStudentsGoalsR200ResponseInnerFromJSON, GetStudentsIdpOverlaysR200ResponseInnerFromJSON, GetStudentsIncompleteAssignmentCountR200ResponseFromJSON, GetStudentsLoginEventsR200ResponseInnerFromJSON, GetStudentsMathNumberBasicsSnapshotsLatestR200ResponseFromJSON, GetStudentsMeMathAdaptivePretestStatusR200ResponseFromJSON, GetStudentsProgressAndGrowthR200ResponseInnerFromJSON, GetStudentsR200ResponseInnerFromJSON, GetStudentsSharesR200ResponseInnerFromJSON, GetStudentsTeachersR200ResponseInnerFromJSON, GetStudentsTimeSpentR200ResponseFromJSON, GetSubjectAcademicVocabularyR200ResponseInnerFromJSON, GetSubjectProductSessionAnswersR200ResponseInnerFromJSON, GetSubjectProductSessionsR200ResponseInnerFromJSON, GetTeacherClaimedFreeResourcesR200ResponseFromJSON, GetTeacherLicenseAllocationsR200ResponseInnerFromJSON, GetTeachersMeR200ResponseFromJSON, GetTeachersR200ResponseInnerFromJSON, GetTeachersSessionsR200ResponseFromJSON, GetV3CoursesR200ResponseInnerFromJSON, GetV3StudentPracticeSummaryR200ResponseFromJSON, GetV3StudentsPresenceEventsR200ResponseInnerFromJSON, GetV3TeachersR200ResponseInnerFromJSON, PatchElaAdaptiveSkillsAnswersR200ResponseFromJSON, PatchRostersR200ResponseInnerFromJSON, PatchStudentsGoalR200ResponseFromJSON, PostContentAreaAdaptiveQuestionsArbitraryR200ResponseFromJSON, PostContentAreaQuestionsArbitraryR200ResponseInnerFromJSON, PostCourseSubjectProductPrintableAssignmentsR200ResponseFromJSON, PostDistrictStudentsPlacementsContentAreaR200ResponseFromJSON, PostDistrictStudentsPlacementsContentAreaReadingR200ResponseFromJSON, PostElaArticleReadingAnswersR200ResponseFromJSON, PostElaArticleReadingAnswersRetriesR200ResponseFromJSON, PostElaDecodablesAssignmentsR200ResponseFromJSON, PostElaSightWordsSessionsR200ResponseFromJSON, PostItemsItemOwnershipR200ResponseFromJSON, PostPasswordsResetsR200ResponseFromJSON, PostRostersSisIdSyncR200ResponseInnerFromJSON, PostSchoolAdminsBulkUploadR200ResponseInnerFromJSON, PostSchoolAdminsTeacherSessionsR200ResponseFromJSON, PostStudentsArchiveForCourseR200ResponseFromJSON, } from '../models/index';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     * deleteConsoleAgentR
     */
    deleteConsoleAgentRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/console/agent`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteConsoleAgentR
     */
    deleteConsoleAgentR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteConsoleAgentRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteCourseMembershipR
     */
    deleteCourseMembershipRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseMembershipRCourseMembershipId'] == null) {
                throw new runtime.RequiredError('courseMembershipRCourseMembershipId', 'Required parameter "courseMembershipRCourseMembershipId" was null or undefined when calling deleteCourseMembershipR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/course-memberships/{CourseMembershipR-CourseMembershipId}`.replace(`{${"CourseMembershipR-CourseMembershipId"}}`, encodeURIComponent(String(requestParameters['courseMembershipRCourseMembershipId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteCourseMembershipR
     */
    deleteCourseMembershipR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteCourseMembershipRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteCourseR
     */
    deleteCourseRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseRCourseId'] == null) {
                throw new runtime.RequiredError('courseRCourseId', 'Required parameter "courseRCourseId" was null or undefined when calling deleteCourseR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseR-CourseId}`.replace(`{${"CourseR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseRCourseId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteCourseR
     */
    deleteCourseR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteCourseRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteCourseStudentSubjectEnabledDashboardModesR
     */
    deleteCourseStudentSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseStudentSubjectEnabledDashboardModesRCourseId'] == null) {
                throw new runtime.RequiredError('courseStudentSubjectEnabledDashboardModesRCourseId', 'Required parameter "courseStudentSubjectEnabledDashboardModesRCourseId" was null or undefined when calling deleteCourseStudentSubjectEnabledDashboardModesR().');
            }
            if (requestParameters['courseStudentSubjectEnabledDashboardModesRStudentId'] == null) {
                throw new runtime.RequiredError('courseStudentSubjectEnabledDashboardModesRStudentId', 'Required parameter "courseStudentSubjectEnabledDashboardModesRStudentId" was null or undefined when calling deleteCourseStudentSubjectEnabledDashboardModesR().');
            }
            if (requestParameters['courseStudentSubjectEnabledDashboardModesRSubject'] == null) {
                throw new runtime.RequiredError('courseStudentSubjectEnabledDashboardModesRSubject', 'Required parameter "courseStudentSubjectEnabledDashboardModesRSubject" was null or undefined when calling deleteCourseStudentSubjectEnabledDashboardModesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseStudentSubjectEnabledDashboardModesR-CourseId}/students/{CourseStudentSubjectEnabledDashboardModesR-StudentId}/subjects/{CourseStudentSubjectEnabledDashboardModesR-Subject}/enabled-practice-modes`.replace(`{${"CourseStudentSubjectEnabledDashboardModesR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseStudentSubjectEnabledDashboardModesRCourseId']))).replace(`{${"CourseStudentSubjectEnabledDashboardModesR-StudentId"}}`, encodeURIComponent(String(requestParameters['courseStudentSubjectEnabledDashboardModesRStudentId']))).replace(`{${"CourseStudentSubjectEnabledDashboardModesR-Subject"}}`, encodeURIComponent(String(requestParameters['courseStudentSubjectEnabledDashboardModesRSubject']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteCourseStudentSubjectEnabledDashboardModesR
     */
    deleteCourseStudentSubjectEnabledDashboardModesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteCourseStudentSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteCourseSubjectEnabledDashboardModesR
     */
    deleteCourseSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseSubjectEnabledDashboardModesRCourseId'] == null) {
                throw new runtime.RequiredError('courseSubjectEnabledDashboardModesRCourseId', 'Required parameter "courseSubjectEnabledDashboardModesRCourseId" was null or undefined when calling deleteCourseSubjectEnabledDashboardModesR().');
            }
            if (requestParameters['courseSubjectEnabledDashboardModesRSubject'] == null) {
                throw new runtime.RequiredError('courseSubjectEnabledDashboardModesRSubject', 'Required parameter "courseSubjectEnabledDashboardModesRSubject" was null or undefined when calling deleteCourseSubjectEnabledDashboardModesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseSubjectEnabledDashboardModesR-CourseId}/subjects/{CourseSubjectEnabledDashboardModesR-Subject}/enabled-practice-modes`.replace(`{${"CourseSubjectEnabledDashboardModesR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseSubjectEnabledDashboardModesRCourseId']))).replace(`{${"CourseSubjectEnabledDashboardModesR-Subject"}}`, encodeURIComponent(String(requestParameters['courseSubjectEnabledDashboardModesRSubject']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteCourseSubjectEnabledDashboardModesR
     */
    deleteCourseSubjectEnabledDashboardModesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteCourseSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteCoursesUnmanagedR
     */
    deleteCoursesUnmanagedRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/unmanaged`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesUnmanagedR200ResponseInnerFromJSON));
        });
    }
    /**
     * deleteCoursesUnmanagedR
     */
    deleteCoursesUnmanagedR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteCoursesUnmanagedRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteDistrictIdentityProviderAssociationsR
     */
    deleteDistrictIdentityProviderAssociationsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling deleteDistrictIdentityProviderAssociationsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/identity-providers/associations`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteDistrictIdentityProviderAssociationsR
     */
    deleteDistrictIdentityProviderAssociationsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteDistrictIdentityProviderAssociationsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteDistrictR
     */
    deleteDistrictRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling deleteDistrictR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteDistrictR
     */
    deleteDistrictR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteDistrictRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteDistrictSchoolAdminSchoolMembershipsR
     */
    deleteDistrictSchoolAdminSchoolMembershipsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling deleteDistrictSchoolAdminSchoolMembershipsR().');
            }
            if (requestParameters['districtSchoolAdminPSchoolAdminId'] == null) {
                throw new runtime.RequiredError('districtSchoolAdminPSchoolAdminId', 'Required parameter "districtSchoolAdminPSchoolAdminId" was null or undefined when calling deleteDistrictSchoolAdminSchoolMembershipsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/school-admins/{DistrictSchoolAdminP-SchoolAdminId}/school-memberships`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))).replace(`{${"DistrictSchoolAdminP-SchoolAdminId"}}`, encodeURIComponent(String(requestParameters['districtSchoolAdminPSchoolAdminId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteDistrictSchoolAdminSchoolMembershipsR
     */
    deleteDistrictSchoolAdminSchoolMembershipsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteDistrictSchoolAdminSchoolMembershipsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteElaWordStudyAssignmentR
     */
    deleteElaWordStudyAssignmentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaWordStudyAssignmentRWordStudyAssignmentId'] == null) {
                throw new runtime.RequiredError('elaWordStudyAssignmentRWordStudyAssignmentId', 'Required parameter "elaWordStudyAssignmentRWordStudyAssignmentId" was null or undefined when calling deleteElaWordStudyAssignmentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/word-study/{ElaWordStudyAssignmentR-WordStudyAssignmentId}`.replace(`{${"ElaWordStudyAssignmentR-WordStudyAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaWordStudyAssignmentRWordStudyAssignmentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteElaWordStudyAssignmentR
     */
    deleteElaWordStudyAssignmentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteElaWordStudyAssignmentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteLicenseAllocationR
     */
    deleteLicenseAllocationRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['licenseAllocationPLicenseAllocationId'] == null) {
                throw new runtime.RequiredError('licenseAllocationPLicenseAllocationId', 'Required parameter "licenseAllocationPLicenseAllocationId" was null or undefined when calling deleteLicenseAllocationR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/license-allocations/{LicenseAllocationP-LicenseAllocationId}`.replace(`{${"LicenseAllocationP-LicenseAllocationId"}}`, encodeURIComponent(String(requestParameters['licenseAllocationPLicenseAllocationId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteLicenseAllocationR
     */
    deleteLicenseAllocationR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteLicenseAllocationRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteLicenseR
     */
    deleteLicenseRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['licensePLicenseId'] == null) {
                throw new runtime.RequiredError('licensePLicenseId', 'Required parameter "licensePLicenseId" was null or undefined when calling deleteLicenseR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/licenses/{LicenseP-LicenseId}`.replace(`{${"LicenseP-LicenseId"}}`, encodeURIComponent(String(requestParameters['licensePLicenseId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteLicenseR
     */
    deleteLicenseR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteLicenseRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteMathAdaptiveAssignmentR
     */
    deleteMathAdaptiveAssignmentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathAdaptiveAssignmentRMathAdaptiveAssignmentId'] == null) {
                throw new runtime.RequiredError('mathAdaptiveAssignmentRMathAdaptiveAssignmentId', 'Required parameter "mathAdaptiveAssignmentRMathAdaptiveAssignmentId" was null or undefined when calling deleteMathAdaptiveAssignmentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-adaptive-assignments/{MathAdaptiveAssignmentR-MathAdaptiveAssignmentId}`.replace(`{${"MathAdaptiveAssignmentR-MathAdaptiveAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathAdaptiveAssignmentRMathAdaptiveAssignmentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteMathAdaptiveAssignmentR
     */
    deleteMathAdaptiveAssignmentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteMathAdaptiveAssignmentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteMathTargetedAssignmentsR
     */
    deleteMathTargetedAssignmentsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathTargetedAssignmentsRMathStandardAssignmentId'] == null) {
                throw new runtime.RequiredError('mathTargetedAssignmentsRMathStandardAssignmentId', 'Required parameter "mathTargetedAssignmentsRMathStandardAssignmentId" was null or undefined when calling deleteMathTargetedAssignmentsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-targeted-assignments/{MathTargetedAssignmentsR-MathStandardAssignmentId}`.replace(`{${"MathTargetedAssignmentsR-MathStandardAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathTargetedAssignmentsRMathStandardAssignmentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteMathTargetedAssignmentsR
     */
    deleteMathTargetedAssignmentsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteMathTargetedAssignmentsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSchoolAdminR
     */
    deleteSchoolAdminRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolAdminPSchoolAdminId'] == null) {
                throw new runtime.RequiredError('schoolAdminPSchoolAdminId', 'Required parameter "schoolAdminPSchoolAdminId" was null or undefined when calling deleteSchoolAdminR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/{SchoolAdminP-SchoolAdminId}`.replace(`{${"SchoolAdminP-SchoolAdminId"}}`, encodeURIComponent(String(requestParameters['schoolAdminPSchoolAdminId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteSchoolAdminR
     */
    deleteSchoolAdminR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSchoolAdminRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSchoolAdminsSessionsR
     */
    deleteSchoolAdminsSessionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/sessions`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DeleteStudentsSessionsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * deleteSchoolAdminsSessionsR
     */
    deleteSchoolAdminsSessionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSchoolAdminsSessionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSchoolIdentityProviderAssociationsR
     */
    deleteSchoolIdentityProviderAssociationsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling deleteSchoolIdentityProviderAssociationsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/identity-providers/associations`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * deleteSchoolIdentityProviderAssociationsR
     */
    deleteSchoolIdentityProviderAssociationsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSchoolIdentityProviderAssociationsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSchoolR
     */
    deleteSchoolRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling deleteSchoolR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetDistrictSchoolsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * deleteSchoolR
     */
    deleteSchoolR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSchoolRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSchoolsSchoolAdminSchoolMembershipsR
     */
    deleteSchoolsSchoolAdminSchoolMembershipsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolsSchoolAdminSchoolMembershipsRNonEmptySchoolId'] == null) {
                throw new runtime.RequiredError('schoolsSchoolAdminSchoolMembershipsRNonEmptySchoolId', 'Required parameter "schoolsSchoolAdminSchoolMembershipsRNonEmptySchoolId" was null or undefined when calling deleteSchoolsSchoolAdminSchoolMembershipsR().');
            }
            if (requestParameters['schoolsSchoolAdminSchoolMembershipsRSchoolAdminId'] == null) {
                throw new runtime.RequiredError('schoolsSchoolAdminSchoolMembershipsRSchoolAdminId', 'Required parameter "schoolsSchoolAdminSchoolMembershipsRSchoolAdminId" was null or undefined when calling deleteSchoolsSchoolAdminSchoolMembershipsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolsSchoolAdminSchoolMembershipsR-NonEmptySchoolId}/school-admins/{SchoolsSchoolAdminSchoolMembershipsR-SchoolAdminId}/school-memberships`.replace(`{${"SchoolsSchoolAdminSchoolMembershipsR-NonEmptySchoolId"}}`, encodeURIComponent(String(requestParameters['schoolsSchoolAdminSchoolMembershipsRNonEmptySchoolId']))).replace(`{${"SchoolsSchoolAdminSchoolMembershipsR-SchoolAdminId"}}`, encodeURIComponent(String(requestParameters['schoolsSchoolAdminSchoolMembershipsRSchoolAdminId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * deleteSchoolsSchoolAdminSchoolMembershipsR
     */
    deleteSchoolsSchoolAdminSchoolMembershipsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSchoolsSchoolAdminSchoolMembershipsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteScienceReadingAssignmentR
     */
    deleteScienceReadingAssignmentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceReadingAssignmentRScienceReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceReadingAssignmentRScienceReadingAssignmentId', 'Required parameter "scienceReadingAssignmentRScienceReadingAssignmentId" was null or undefined when calling deleteScienceReadingAssignmentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/reading/{ScienceReadingAssignmentR-ScienceReadingAssignmentId}`.replace(`{${"ScienceReadingAssignmentR-ScienceReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceReadingAssignmentRScienceReadingAssignmentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteScienceReadingAssignmentR
     */
    deleteScienceReadingAssignmentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteScienceReadingAssignmentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteScienceWritingAssignmentR
     */
    deleteScienceWritingAssignmentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceWritingAssignmentRScienceWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceWritingAssignmentRScienceWritingAssignmentId', 'Required parameter "scienceWritingAssignmentRScienceWritingAssignmentId" was null or undefined when calling deleteScienceWritingAssignmentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/writing/{ScienceWritingAssignmentR-ScienceWritingAssignmentId}`.replace(`{${"ScienceWritingAssignmentR-ScienceWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceWritingAssignmentRScienceWritingAssignmentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteScienceWritingAssignmentR
     */
    deleteScienceWritingAssignmentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteScienceWritingAssignmentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSocialStudiesReadingAssignmentR
     */
    deleteSocialStudiesReadingAssignmentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesReadingAssignmentRSocialStudiesReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesReadingAssignmentRSocialStudiesReadingAssignmentId', 'Required parameter "socialStudiesReadingAssignmentRSocialStudiesReadingAssignmentId" was null or undefined when calling deleteSocialStudiesReadingAssignmentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/reading/{SocialStudiesReadingAssignmentR-SocialStudiesReadingAssignmentId}`.replace(`{${"SocialStudiesReadingAssignmentR-SocialStudiesReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesReadingAssignmentRSocialStudiesReadingAssignmentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteSocialStudiesReadingAssignmentR
     */
    deleteSocialStudiesReadingAssignmentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSocialStudiesReadingAssignmentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSocialStudiesWritingAssignmentR
     */
    deleteSocialStudiesWritingAssignmentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesWritingAssignmentRSocialStudiesWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesWritingAssignmentRSocialStudiesWritingAssignmentId', 'Required parameter "socialStudiesWritingAssignmentRSocialStudiesWritingAssignmentId" was null or undefined when calling deleteSocialStudiesWritingAssignmentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/writing/{SocialStudiesWritingAssignmentR-SocialStudiesWritingAssignmentId}`.replace(`{${"SocialStudiesWritingAssignmentR-SocialStudiesWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesWritingAssignmentRSocialStudiesWritingAssignmentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteSocialStudiesWritingAssignmentR
     */
    deleteSocialStudiesWritingAssignmentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSocialStudiesWritingAssignmentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteStudentMathProgressR
     */
    deleteStudentMathProgressRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3StudentPStudentId'] == null) {
                throw new runtime.RequiredError('v3StudentPStudentId', 'Required parameter "v3StudentPStudentId" was null or undefined when calling deleteStudentMathProgressR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/{V3StudentP-StudentId}/math/progress`.replace(`{${"V3StudentP-StudentId"}}`, encodeURIComponent(String(requestParameters['v3StudentPStudentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteStudentMathProgressR
     */
    deleteStudentMathProgressR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteStudentMathProgressRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteStudentR
     */
    deleteStudentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentRStudentId'] == null) {
                throw new runtime.RequiredError('studentRStudentId', 'Required parameter "studentRStudentId" was null or undefined when calling deleteStudentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentR-StudentId}`.replace(`{${"StudentR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentRStudentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteStudentR
     */
    deleteStudentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteStudentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteStudentsElaSnapshotsR
     */
    deleteStudentsElaSnapshotsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentsElaSnapshotsRStudentId'] == null) {
                throw new runtime.RequiredError('studentsElaSnapshotsRStudentId', 'Required parameter "studentsElaSnapshotsRStudentId" was null or undefined when calling deleteStudentsElaSnapshotsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentsElaSnapshotsR-StudentId}/ela-snapshots`.replace(`{${"StudentsElaSnapshotsR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentsElaSnapshotsRStudentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteStudentsElaSnapshotsR
     */
    deleteStudentsElaSnapshotsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteStudentsElaSnapshotsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteStudentsIdpOverlayR
     */
    deleteStudentsIdpOverlayRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentsIdpOverlayRIdpOverlayStudentId'] == null) {
                throw new runtime.RequiredError('studentsIdpOverlayRIdpOverlayStudentId', 'Required parameter "studentsIdpOverlayRIdpOverlayStudentId" was null or undefined when calling deleteStudentsIdpOverlayR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/student-idp-overlays/{StudentsIdpOverlayR-IdpOverlayStudentId}`.replace(`{${"StudentsIdpOverlayR-IdpOverlayStudentId"}}`, encodeURIComponent(String(requestParameters['studentsIdpOverlayRIdpOverlayStudentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteStudentsIdpOverlayR
     */
    deleteStudentsIdpOverlayR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteStudentsIdpOverlayRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteStudentsSessionsR
     */
    deleteStudentsSessionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/sessions`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DeleteStudentsSessionsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * deleteStudentsSessionsR
     */
    deleteStudentsSessionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteStudentsSessionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteStudentsSharesR
     */
    deleteStudentsSharesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/student-shares`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteStudentsSharesR
     */
    deleteStudentsSharesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteStudentsSharesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteStudentsWordStudySessionsR
     */
    deleteStudentsWordStudySessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentsWordStudySessionsRStudentId'] == null) {
                throw new runtime.RequiredError('studentsWordStudySessionsRStudentId', 'Required parameter "studentsWordStudySessionsRStudentId" was null or undefined when calling deleteStudentsWordStudySessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentsWordStudySessionsR-StudentId}/word-study-sessions`.replace(`{${"StudentsWordStudySessionsR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentsWordStudySessionsRStudentId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteStudentsWordStudySessionsR
     */
    deleteStudentsWordStudySessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteStudentsWordStudySessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSubjectProductAssignmentR
     */
    deleteSubjectProductAssignmentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling deleteSubjectProductAssignmentR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling deleteSubjectProductAssignmentR().');
            }
            if (requestParameters['subjectProductAssignmentPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductAssignmentPInt64', 'Required parameter "subjectProductAssignmentPInt64" was null or undefined when calling deleteSubjectProductAssignmentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/assignments/{SubjectProductAssignmentP-Int64}`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductAssignmentP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductAssignmentPInt64']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteSubjectProductAssignmentR
     */
    deleteSubjectProductAssignmentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSubjectProductAssignmentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSubjectProductSessionSentimentR
     */
    deleteSubjectProductSessionSentimentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling deleteSubjectProductSessionSentimentR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling deleteSubjectProductSessionSentimentR().');
            }
            if (requestParameters['subjectProductSessionPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductSessionPInt64', 'Required parameter "subjectProductSessionPInt64" was null or undefined when calling deleteSubjectProductSessionSentimentR().');
            }
            if (requestParameters['subjectProductSessionSentimentPSentiment'] == null) {
                throw new runtime.RequiredError('subjectProductSessionSentimentPSentiment', 'Required parameter "subjectProductSessionSentimentPSentiment" was null or undefined when calling deleteSubjectProductSessionSentimentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions/{SubjectProductSessionP-Int64}/sentiments/{SubjectProductSessionSentimentP-Sentiment}`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductSessionP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionPInt64']))).replace(`{${"SubjectProductSessionSentimentP-Sentiment"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionSentimentPSentiment']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteSubjectProductSessionSentimentR
     */
    deleteSubjectProductSessionSentimentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSubjectProductSessionSentimentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteSubjectProductSessionsR
     */
    deleteSubjectProductSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling deleteSubjectProductSessionsR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling deleteSubjectProductSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteSubjectProductSessionsR
     */
    deleteSubjectProductSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteSubjectProductSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteTeacherIdpCleverR
     */
    deleteTeacherIdpCleverRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teacherIdpCleverRTeacherId'] == null) {
                throw new runtime.RequiredError('teacherIdpCleverRTeacherId', 'Required parameter "teacherIdpCleverRTeacherId" was null or undefined when calling deleteTeacherIdpCleverR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeacherIdpCleverR-TeacherId}/idp/clever`.replace(`{${"TeacherIdpCleverR-TeacherId"}}`, encodeURIComponent(String(requestParameters['teacherIdpCleverRTeacherId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteTeacherIdpCleverR
     */
    deleteTeacherIdpCleverR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteTeacherIdpCleverRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteTeacherR
     */
    deleteTeacherRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teacherRTeacherId'] == null) {
                throw new runtime.RequiredError('teacherRTeacherId', 'Required parameter "teacherRTeacherId" was null or undefined when calling deleteTeacherR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeacherR-TeacherId}`.replace(`{${"TeacherR-TeacherId"}}`, encodeURIComponent(String(requestParameters['teacherRTeacherId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteTeacherR
     */
    deleteTeacherR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteTeacherRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteTeachersAffiliationR
     */
    deleteTeachersAffiliationRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teachersAffiliationRTeacherId'] == null) {
                throw new runtime.RequiredError('teachersAffiliationRTeacherId', 'Required parameter "teachersAffiliationRTeacherId" was null or undefined when calling deleteTeachersAffiliationR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeachersAffiliationR-TeacherId}/affiliation`.replace(`{${"TeachersAffiliationR-TeacherId"}}`, encodeURIComponent(String(requestParameters['teachersAffiliationRTeacherId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * deleteTeachersAffiliationR
     */
    deleteTeachersAffiliationR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteTeachersAffiliationRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteTeachersAffiliationsR
     */
    deleteTeachersAffiliationsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/affiliations`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DeleteTeachersAffiliationsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * deleteTeachersAffiliationsR
     */
    deleteTeachersAffiliationsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteTeachersAffiliationsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * deleteTeachersSessionsR
     */
    deleteTeachersSessionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/sessions`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DeleteStudentsSessionsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * deleteTeachersSessionsR
     */
    deleteTeachersSessionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.deleteTeachersSessionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getActivityFeedForCourseR
     */
    getActivityFeedForCourseRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['activityFeedForCourseRCourseId'] == null) {
                throw new runtime.RequiredError('activityFeedForCourseRCourseId', 'Required parameter "activityFeedForCourseRCourseId" was null or undefined when calling getActivityFeedForCourseR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{ActivityFeedForCourseR-CourseId}/activity-feed`.replace(`{${"ActivityFeedForCourseR-CourseId"}}`, encodeURIComponent(String(requestParameters['activityFeedForCourseRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetActivityFeedForCourseR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getActivityFeedForCourseR
     */
    getActivityFeedForCourseR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getActivityFeedForCourseRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getActivityFeedForStudentR
     */
    getActivityFeedForStudentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['activityFeedForStudentRStudentId'] == null) {
                throw new runtime.RequiredError('activityFeedForStudentRStudentId', 'Required parameter "activityFeedForStudentRStudentId" was null or undefined when calling getActivityFeedForStudentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{ActivityFeedForStudentR-StudentId}/activity-feed`.replace(`{${"ActivityFeedForStudentR-StudentId"}}`, encodeURIComponent(String(requestParameters['activityFeedForStudentRStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetActivityFeedForStudentR200ResponseInnerFromJSON));
        });
    }
    /**
     * getActivityFeedForStudentR
     */
    getActivityFeedForStudentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getActivityFeedForStudentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getAssignmentCountR
     */
    getAssignmentCountRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/assignment-count`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsIncompleteAssignmentCountR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getAssignmentCountR
     */
    getAssignmentCountR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAssignmentCountRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getAuthCheckR
     */
    getAuthCheckRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/auth-check`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getAuthCheckR
     */
    getAuthCheckR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAuthCheckRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getBoomR
     */
    getBoomRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/boom`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getBoomR
     */
    getBoomR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getBoomRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getColleaguesR
     */
    getColleaguesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/colleagues`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSchoolColleaguesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getColleaguesR
     */
    getColleaguesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getColleaguesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getConnectionCheckR
     */
    getConnectionCheckRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/connection-check`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getConnectionCheckR
     */
    getConnectionCheckR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getConnectionCheckRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getConsoleAgentR
     */
    getConsoleAgentRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/console/agent`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetConsoleAgentR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getConsoleAgentR
     */
    getConsoleAgentR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getConsoleAgentRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaAdaptiveAnswersR
     */
    getContentAreaAdaptiveAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaAdaptiveAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/adaptive/answers`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContentAreaAdaptiveAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getContentAreaAdaptiveAnswersR
     */
    getContentAreaAdaptiveAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaAdaptiveAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaAdaptiveProgressesR
     */
    getContentAreaAdaptiveProgressesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaAdaptiveProgressesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/adaptive-progresses`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContentAreaAdaptiveProgressesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getContentAreaAdaptiveProgressesR
     */
    getContentAreaAdaptiveProgressesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaAdaptiveProgressesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaAdaptiveRewardsR
     */
    getContentAreaAdaptiveRewardsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaAdaptiveRewardsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/adaptive/rewards`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentMathAdaptiveRewardsR200ResponseInnerRewardFromJSON));
        });
    }
    /**
     * getContentAreaAdaptiveRewardsR
     */
    getContentAreaAdaptiveRewardsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaAdaptiveRewardsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaConstructedResponsesR
     */
    getContentAreaConstructedResponsesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaConstructedResponsesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/constructed-responses`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContentAreaConstructedResponsesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getContentAreaConstructedResponsesR
     */
    getContentAreaConstructedResponsesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaConstructedResponsesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaDepthOfKnowledgeQuestionSetsR
     */
    getContentAreaDepthOfKnowledgeQuestionSetsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaDepthOfKnowledgeQuestionSetsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/depth-of-knowledge/question-sets`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContentAreaDepthOfKnowledgeQuestionSetsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getContentAreaDepthOfKnowledgeQuestionSetsR
     */
    getContentAreaDepthOfKnowledgeQuestionSetsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaDepthOfKnowledgeQuestionSetsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaDomainTranslationR
     */
    getContentAreaDomainTranslationRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaDomainTranslationR().');
            }
            if (requestParameters['contentAreaDomainPRlDomainId'] == null) {
                throw new runtime.RequiredError('contentAreaDomainPRlDomainId', 'Required parameter "contentAreaDomainPRlDomainId" was null or undefined when calling getContentAreaDomainTranslationR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/domains/{ContentAreaDomainP-RlDomainId}/translation`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))).replace(`{${"ContentAreaDomainP-RlDomainId"}}`, encodeURIComponent(String(requestParameters['contentAreaDomainPRlDomainId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetContentAreaDomainTranslationR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getContentAreaDomainTranslationR
     */
    getContentAreaDomainTranslationR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaDomainTranslationRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaDomainsExclusionsR
     */
    getContentAreaDomainsExclusionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaDomainsExclusionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/domains/exclusions`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContentAreaDomainsExclusionsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getContentAreaDomainsExclusionsR
     */
    getContentAreaDomainsExclusionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaDomainsExclusionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaIblsR
     */
    getContentAreaIblsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaIblsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/ibls`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContentAreaIblsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getContentAreaIblsR
     */
    getContentAreaIblsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaIblsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaSkillProficienciesProgressR
     */
    getContentAreaSkillProficienciesProgressRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaSkillProficienciesProgressR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/skill-proficiencies/progress`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetContentAreaSkillProficienciesProgressR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getContentAreaSkillProficienciesProgressR
     */
    getContentAreaSkillProficienciesProgressR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaSkillProficienciesProgressRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaSkillProficienciesR
     */
    getContentAreaSkillProficienciesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaSkillProficienciesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/skill-proficiencies`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContentAreaSkillProficienciesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getContentAreaSkillProficienciesR
     */
    getContentAreaSkillProficienciesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaSkillProficienciesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaSkillsR
     */
    getContentAreaSkillsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaSkillsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/skills`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContentAreaSkillsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getContentAreaSkillsR
     */
    getContentAreaSkillsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaSkillsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getContentAreaVideosR
     */
    getContentAreaVideosRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling getContentAreaVideosR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/videos`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetContentAreaVideosR200ResponseInnerFromJSON));
        });
    }
    /**
     * getContentAreaVideosR
     */
    getContentAreaVideosR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getContentAreaVideosRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseElaAdaptiveSkillsAdaptiveProgressesR
     */
    getCourseElaAdaptiveSkillsAdaptiveProgressesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling getCourseElaAdaptiveSkillsAdaptiveProgressesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/ela-adaptive-skills/adaptive-progresses`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseElaAdaptiveSkillsAdaptiveProgressesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseElaAdaptiveSkillsAdaptiveProgressesR
     */
    getCourseElaAdaptiveSkillsAdaptiveProgressesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseElaAdaptiveSkillsAdaptiveProgressesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseElaAdaptiveSkillsSkillGroupsReportR
     */
    getCourseElaAdaptiveSkillsSkillGroupsReportRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling getCourseElaAdaptiveSkillsSkillGroupsReportR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/ela-adaptive-skills/skill-groups-report`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseElaAdaptiveSkillsSkillGroupsReportR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseElaAdaptiveSkillsSkillGroupsReportR
     */
    getCourseElaAdaptiveSkillsSkillGroupsReportR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseElaAdaptiveSkillsSkillGroupsReportRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseEnabledDashboardModesR
     */
    getCourseEnabledDashboardModesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseEnabledDashboardModesRCourseId'] == null) {
                throw new runtime.RequiredError('courseEnabledDashboardModesRCourseId', 'Required parameter "courseEnabledDashboardModesRCourseId" was null or undefined when calling getCourseEnabledDashboardModesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseEnabledDashboardModesR-CourseId}/enabled-practice-modes`.replace(`{${"CourseEnabledDashboardModesR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseEnabledDashboardModesRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseEnabledDashboardModesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseEnabledDashboardModesR
     */
    getCourseEnabledDashboardModesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseEnabledDashboardModesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseExpertsElaAdaptiveSkillsR
     */
    getCourseExpertsElaAdaptiveSkillsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseExpertsElaAdaptiveSkillsRCourseId'] == null) {
                throw new runtime.RequiredError('courseExpertsElaAdaptiveSkillsRCourseId', 'Required parameter "courseExpertsElaAdaptiveSkillsRCourseId" was null or undefined when calling getCourseExpertsElaAdaptiveSkillsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseExpertsElaAdaptiveSkillsR-CourseId}/experts/ela-adaptive-skills`.replace(`{${"CourseExpertsElaAdaptiveSkillsR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseExpertsElaAdaptiveSkillsRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesStudentsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseExpertsElaAdaptiveSkillsR
     */
    getCourseExpertsElaAdaptiveSkillsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseExpertsElaAdaptiveSkillsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseExpertsMathAdaptiveR
     */
    getCourseExpertsMathAdaptiveRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseExpertsMathAdaptiveRCourseId'] == null) {
                throw new runtime.RequiredError('courseExpertsMathAdaptiveRCourseId', 'Required parameter "courseExpertsMathAdaptiveRCourseId" was null or undefined when calling getCourseExpertsMathAdaptiveR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseExpertsMathAdaptiveR-CourseId}/experts/math-adaptive`.replace(`{${"CourseExpertsMathAdaptiveR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseExpertsMathAdaptiveRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesStudentsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseExpertsMathAdaptiveR
     */
    getCourseExpertsMathAdaptiveR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseExpertsMathAdaptiveRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseExpertsWordStudyR
     */
    getCourseExpertsWordStudyRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseExpertsWordStudyRCourseId'] == null) {
                throw new runtime.RequiredError('courseExpertsWordStudyRCourseId', 'Required parameter "courseExpertsWordStudyRCourseId" was null or undefined when calling getCourseExpertsWordStudyR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseExpertsWordStudyR-CourseId}/experts/word-study`.replace(`{${"CourseExpertsWordStudyR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseExpertsWordStudyRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesStudentsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseExpertsWordStudyR
     */
    getCourseExpertsWordStudyR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseExpertsWordStudyRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseMathAssessmentsDomainGrowthReportR
     */
    getCourseMathAssessmentsDomainGrowthReportRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling getCourseMathAssessmentsDomainGrowthReportR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/math-assessments/domain-growth-report`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseMathAssessmentsStandardGrowthReportR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseMathAssessmentsDomainGrowthReportR
     */
    getCourseMathAssessmentsDomainGrowthReportR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseMathAssessmentsDomainGrowthReportRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseMathAssessmentsGrowthReportR
     */
    getCourseMathAssessmentsGrowthReportRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling getCourseMathAssessmentsGrowthReportR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/math-assessments/growth-report`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseMathAssessmentsGrowthReportR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseMathAssessmentsGrowthReportR
     */
    getCourseMathAssessmentsGrowthReportR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseMathAssessmentsGrowthReportRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseMathAssessmentsStandardGrowthReportR
     */
    getCourseMathAssessmentsStandardGrowthReportRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling getCourseMathAssessmentsStandardGrowthReportR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/math-assessments/standard-growth-report`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseMathAssessmentsStandardGrowthReportR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseMathAssessmentsStandardGrowthReportR
     */
    getCourseMathAssessmentsStandardGrowthReportR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseMathAssessmentsStandardGrowthReportRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseMathAssessmentsStudentGrowthReportR
     */
    getCourseMathAssessmentsStudentGrowthReportRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling getCourseMathAssessmentsStudentGrowthReportR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/math-assessments/student-growth-report`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseMathAssessmentsStandardGrowthReportR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseMathAssessmentsStudentGrowthReportR
     */
    getCourseMathAssessmentsStudentGrowthReportR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseMathAssessmentsStudentGrowthReportRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseMembershipsR
     */
    getCourseMembershipsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/course-memberships`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseMembershipsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseMembershipsR
     */
    getCourseMembershipsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseMembershipsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseR
     */
    getCourseRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseRCourseId'] == null) {
                throw new runtime.RequiredError('courseRCourseId', 'Required parameter "courseRCourseId" was null or undefined when calling getCourseR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseR-CourseId}`.replace(`{${"CourseR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCoursesR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * getCourseR
     */
    getCourseR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseReportsElaGroupsByLevelR
     */
    getCourseReportsElaGroupsByLevelRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseReportsElaGroupsByLevelRCourseId'] == null) {
                throw new runtime.RequiredError('courseReportsElaGroupsByLevelRCourseId', 'Required parameter "courseReportsElaGroupsByLevelRCourseId" was null or undefined when calling getCourseReportsElaGroupsByLevelR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseReportsElaGroupsByLevelR-CourseId}/reports/ela/groups-by-level`.replace(`{${"CourseReportsElaGroupsByLevelR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseReportsElaGroupsByLevelRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseReportsElaGroupsByLevelR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseReportsElaGroupsByLevelR
     */
    getCourseReportsElaGroupsByLevelR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseReportsElaGroupsByLevelRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseReportsElaPerformanceByStandardR
     */
    getCourseReportsElaPerformanceByStandardRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseReportsElaPerformanceByStandardRCourseId'] == null) {
                throw new runtime.RequiredError('courseReportsElaPerformanceByStandardRCourseId', 'Required parameter "courseReportsElaPerformanceByStandardRCourseId" was null or undefined when calling getCourseReportsElaPerformanceByStandardR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseReportsElaPerformanceByStandardR-CourseId}/reports/ela/performance-by-standard`.replace(`{${"CourseReportsElaPerformanceByStandardR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseReportsElaPerformanceByStandardRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseReportsElaPerformanceByStandardR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseReportsElaPerformanceByStandardR
     */
    getCourseReportsElaPerformanceByStandardR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseReportsElaPerformanceByStandardRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseStudentSubjectEnabledDashboardModesR
     */
    getCourseStudentSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseStudentSubjectEnabledDashboardModesRCourseId'] == null) {
                throw new runtime.RequiredError('courseStudentSubjectEnabledDashboardModesRCourseId', 'Required parameter "courseStudentSubjectEnabledDashboardModesRCourseId" was null or undefined when calling getCourseStudentSubjectEnabledDashboardModesR().');
            }
            if (requestParameters['courseStudentSubjectEnabledDashboardModesRStudentId'] == null) {
                throw new runtime.RequiredError('courseStudentSubjectEnabledDashboardModesRStudentId', 'Required parameter "courseStudentSubjectEnabledDashboardModesRStudentId" was null or undefined when calling getCourseStudentSubjectEnabledDashboardModesR().');
            }
            if (requestParameters['courseStudentSubjectEnabledDashboardModesRSubject'] == null) {
                throw new runtime.RequiredError('courseStudentSubjectEnabledDashboardModesRSubject', 'Required parameter "courseStudentSubjectEnabledDashboardModesRSubject" was null or undefined when calling getCourseStudentSubjectEnabledDashboardModesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseStudentSubjectEnabledDashboardModesR-CourseId}/students/{CourseStudentSubjectEnabledDashboardModesR-StudentId}/subjects/{CourseStudentSubjectEnabledDashboardModesR-Subject}/enabled-practice-modes`.replace(`{${"CourseStudentSubjectEnabledDashboardModesR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseStudentSubjectEnabledDashboardModesRCourseId']))).replace(`{${"CourseStudentSubjectEnabledDashboardModesR-StudentId"}}`, encodeURIComponent(String(requestParameters['courseStudentSubjectEnabledDashboardModesRStudentId']))).replace(`{${"CourseStudentSubjectEnabledDashboardModesR-Subject"}}`, encodeURIComponent(String(requestParameters['courseStudentSubjectEnabledDashboardModesRSubject']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseEnabledDashboardModesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseStudentSubjectEnabledDashboardModesR
     */
    getCourseStudentSubjectEnabledDashboardModesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseStudentSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseSubjectProductSessionsR
     */
    getCourseSubjectProductSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling getCourseSubjectProductSessionsR().');
            }
            if (requestParameters['courseSubjectPSubject'] == null) {
                throw new runtime.RequiredError('courseSubjectPSubject', 'Required parameter "courseSubjectPSubject" was null or undefined when calling getCourseSubjectProductSessionsR().');
            }
            if (requestParameters['courseProductPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('courseProductPAbbreviatedProduct', 'Required parameter "courseProductPAbbreviatedProduct" was null or undefined when calling getCourseSubjectProductSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/subjects/{CourseSubjectP-Subject}/products/{CourseProductP-AbbreviatedProduct}/sessions`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))).replace(`{${"CourseSubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['courseSubjectPSubject']))).replace(`{${"CourseProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['courseProductPAbbreviatedProduct']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSubjectProductSessionsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseSubjectProductSessionsR
     */
    getCourseSubjectProductSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseSubjectProductSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseSubjectProductSettingsR
     */
    getCourseSubjectProductSettingsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling getCourseSubjectProductSettingsR().');
            }
            if (requestParameters['courseSubjectPSubject'] == null) {
                throw new runtime.RequiredError('courseSubjectPSubject', 'Required parameter "courseSubjectPSubject" was null or undefined when calling getCourseSubjectProductSettingsR().');
            }
            if (requestParameters['courseProductPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('courseProductPAbbreviatedProduct', 'Required parameter "courseProductPAbbreviatedProduct" was null or undefined when calling getCourseSubjectProductSettingsR().');
            }
            if (requestParameters['courseSubjectProductSettingsRStudentId'] == null) {
                throw new runtime.RequiredError('courseSubjectProductSettingsRStudentId', 'Required parameter "courseSubjectProductSettingsRStudentId" was null or undefined when calling getCourseSubjectProductSettingsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/subjects/{CourseSubjectP-Subject}/products/{CourseProductP-AbbreviatedProduct}/settings/{CourseSubjectProductSettingsR-StudentId}`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))).replace(`{${"CourseSubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['courseSubjectPSubject']))).replace(`{${"CourseProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['courseProductPAbbreviatedProduct']))).replace(`{${"CourseSubjectProductSettingsR-StudentId"}}`, encodeURIComponent(String(requestParameters['courseSubjectProductSettingsRStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCourseSubjectProductSettingsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getCourseSubjectProductSettingsR
     */
    getCourseSubjectProductSettingsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseSubjectProductSettingsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCourseSubjectsR
     */
    getCourseSubjectsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseSubjectsRCourseId'] == null) {
                throw new runtime.RequiredError('courseSubjectsRCourseId', 'Required parameter "courseSubjectsRCourseId" was null or undefined when calling getCourseSubjectsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseSubjectsR-CourseId}/subjects`.replace(`{${"CourseSubjectsR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseSubjectsRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseSubjectsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCourseSubjectsR
     */
    getCourseSubjectsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCourseSubjectsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesClassCodesR
     */
    getCoursesClassCodesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesClassCodesRClassCode'] == null) {
                throw new runtime.RequiredError('coursesClassCodesRClassCode', 'Required parameter "coursesClassCodesRClassCode" was null or undefined when calling getCoursesClassCodesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/class-codes/{CoursesClassCodesR-ClassCode}`.replace(`{${"CoursesClassCodesR-ClassCode"}}`, encodeURIComponent(String(requestParameters['coursesClassCodesRClassCode']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCoursesClassCodesR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getCoursesClassCodesR
     */
    getCoursesClassCodesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesClassCodesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesClassDomainGrowthR
     */
    getCoursesClassDomainGrowthRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesClassDomainGrowthRCourseId'] == null) {
                throw new runtime.RequiredError('coursesClassDomainGrowthRCourseId', 'Required parameter "coursesClassDomainGrowthRCourseId" was null or undefined when calling getCoursesClassDomainGrowthR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesClassDomainGrowthR-CourseId}/class-grouping-report/domain-growth`.replace(`{${"CoursesClassDomainGrowthR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesClassDomainGrowthRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesClassDomainGrowthR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesClassDomainGrowthR
     */
    getCoursesClassDomainGrowthR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesClassDomainGrowthRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesCurrentR
     */
    getCoursesCurrentRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/current`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCoursesR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * getCoursesCurrentR
     */
    getCoursesCurrentR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesCurrentRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesMathAdaptiveDomainsPracticedR
     */
    getCoursesMathAdaptiveDomainsPracticedRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling getCoursesMathAdaptiveDomainsPracticedR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/math-adaptive-domains-practiced`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * getCoursesMathAdaptiveDomainsPracticedR
     */
    getCoursesMathAdaptiveDomainsPracticedR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesMathAdaptiveDomainsPracticedRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesMathAdaptiveStatsStudentDomainMonthLatestR
     */
    getCoursesMathAdaptiveStatsStudentDomainMonthLatestRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesMathAdaptiveStatsStudentDomainMonthLatestRCourseId'] == null) {
                throw new runtime.RequiredError('coursesMathAdaptiveStatsStudentDomainMonthLatestRCourseId', 'Required parameter "coursesMathAdaptiveStatsStudentDomainMonthLatestRCourseId" was null or undefined when calling getCoursesMathAdaptiveStatsStudentDomainMonthLatestR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesMathAdaptiveStatsStudentDomainMonthLatestR-CourseId}/math-adaptive-stats-student-domain-month/latest`.replace(`{${"CoursesMathAdaptiveStatsStudentDomainMonthLatestR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesMathAdaptiveStatsStudentDomainMonthLatestRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentMathAdaptiveStatsStudentDomainMonthLatestR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesMathAdaptiveStatsStudentDomainMonthLatestR
     */
    getCoursesMathAdaptiveStatsStudentDomainMonthLatestR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesMathAdaptiveStatsStudentDomainMonthLatestRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesMathDiagnosticsR
     */
    getCoursesMathDiagnosticsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesMathDiagnosticsRCourseId'] == null) {
                throw new runtime.RequiredError('coursesMathDiagnosticsRCourseId', 'Required parameter "coursesMathDiagnosticsRCourseId" was null or undefined when calling getCoursesMathDiagnosticsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesMathDiagnosticsR-CourseId}/math-diagnostics`.replace(`{${"CoursesMathDiagnosticsR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesMathDiagnosticsRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesMathDiagnosticsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesMathDiagnosticsR
     */
    getCoursesMathDiagnosticsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesMathDiagnosticsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesMathFactPracticeLevelsR
     */
    getCoursesMathFactPracticeLevelsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesMathFactPracticeLevelsRCourseId'] == null) {
                throw new runtime.RequiredError('coursesMathFactPracticeLevelsRCourseId', 'Required parameter "coursesMathFactPracticeLevelsRCourseId" was null or undefined when calling getCoursesMathFactPracticeLevelsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesMathFactPracticeLevelsR-CourseId}/math-fact-practice-levels`.replace(`{${"CoursesMathFactPracticeLevelsR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesMathFactPracticeLevelsRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesMathFactPracticeLevelsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesMathFactPracticeLevelsR
     */
    getCoursesMathFactPracticeLevelsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesMathFactPracticeLevelsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesMathReportCardSummariesR
     */
    getCoursesMathReportCardSummariesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesMathReportCardSummariesRCourseId'] == null) {
                throw new runtime.RequiredError('coursesMathReportCardSummariesRCourseId', 'Required parameter "coursesMathReportCardSummariesRCourseId" was null or undefined when calling getCoursesMathReportCardSummariesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesMathReportCardSummariesR-CourseId}/math-report-card-summaries`.replace(`{${"CoursesMathReportCardSummariesR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesMathReportCardSummariesRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesMathReportCardSummariesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesMathReportCardSummariesR
     */
    getCoursesMathReportCardSummariesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesMathReportCardSummariesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesR
     */
    getCoursesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesR
     */
    getCoursesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesReportsMathTargetedAssignmentQuestionPerformanceR
     */
    getCoursesReportsMathTargetedAssignmentQuestionPerformanceRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesReportsMathPCourseId'] == null) {
                throw new runtime.RequiredError('coursesReportsMathPCourseId', 'Required parameter "coursesReportsMathPCourseId" was null or undefined when calling getCoursesReportsMathTargetedAssignmentQuestionPerformanceR().');
            }
            if (requestParameters['coursesReportsMathTargetedAssignmentPMathStandardAssignmentId'] == null) {
                throw new runtime.RequiredError('coursesReportsMathTargetedAssignmentPMathStandardAssignmentId', 'Required parameter "coursesReportsMathTargetedAssignmentPMathStandardAssignmentId" was null or undefined when calling getCoursesReportsMathTargetedAssignmentQuestionPerformanceR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesReportsMathP-CourseId}/reports/math/targeted/assignments/{CoursesReportsMathTargetedAssignmentP-MathStandardAssignmentId}/question-performance`.replace(`{${"CoursesReportsMathP-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesReportsMathPCourseId']))).replace(`{${"CoursesReportsMathTargetedAssignmentP-MathStandardAssignmentId"}}`, encodeURIComponent(String(requestParameters['coursesReportsMathTargetedAssignmentPMathStandardAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesReportsMathTargetedAssignmentQuestionPerformanceR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesReportsMathTargetedAssignmentQuestionPerformanceR
     */
    getCoursesReportsMathTargetedAssignmentQuestionPerformanceR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesReportsMathTargetedAssignmentQuestionPerformanceRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesStudentGoalsR
     */
    getCoursesStudentGoalsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesStudentGoalsRCourseId'] == null) {
                throw new runtime.RequiredError('coursesStudentGoalsRCourseId', 'Required parameter "coursesStudentGoalsRCourseId" was null or undefined when calling getCoursesStudentGoalsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesStudentGoalsR-CourseId}/student-goals`.replace(`{${"CoursesStudentGoalsR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesStudentGoalsRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsGoalsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesStudentGoalsR
     */
    getCoursesStudentGoalsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesStudentGoalsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesStudentStandardStatsR
     */
    getCoursesStudentStandardStatsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesStudentStandardStatsRCourseId'] == null) {
                throw new runtime.RequiredError('coursesStudentStandardStatsRCourseId', 'Required parameter "coursesStudentStandardStatsRCourseId" was null or undefined when calling getCoursesStudentStandardStatsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesStudentStandardStatsR-CourseId}/student-standard-stats`.replace(`{${"CoursesStudentStandardStatsR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesStudentStandardStatsRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesStudentStandardStatsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesStudentStandardStatsR
     */
    getCoursesStudentStandardStatsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesStudentStandardStatsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesStudentsR
     */
    getCoursesStudentsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesStudentsRCourseId'] == null) {
                throw new runtime.RequiredError('coursesStudentsRCourseId', 'Required parameter "coursesStudentsRCourseId" was null or undefined when calling getCoursesStudentsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesStudentsR-CourseId}/students`.replace(`{${"CoursesStudentsR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesStudentsRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesStudentsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesStudentsR
     */
    getCoursesStudentsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesStudentsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesTeacherR
     */
    getCoursesTeacherRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesTeacherRCourseId'] == null) {
                throw new runtime.RequiredError('coursesTeacherRCourseId', 'Required parameter "coursesTeacherRCourseId" was null or undefined when calling getCoursesTeacherR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesTeacherR-CourseId}/teacher`.replace(`{${"CoursesTeacherR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesTeacherRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsTeachersR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * getCoursesTeacherR
     */
    getCoursesTeacherR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesTeacherRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesUnmanagedR
     */
    getCoursesUnmanagedRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/unmanaged`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesUnmanagedR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesUnmanagedR
     */
    getCoursesUnmanagedR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesUnmanagedRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getCoursesWordStudyLevelsLatestPerStudentR
     */
    getCoursesWordStudyLevelsLatestPerStudentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesWordStudyLevelsLatestPerStudentRCourseId'] == null) {
                throw new runtime.RequiredError('coursesWordStudyLevelsLatestPerStudentRCourseId', 'Required parameter "coursesWordStudyLevelsLatestPerStudentRCourseId" was null or undefined when calling getCoursesWordStudyLevelsLatestPerStudentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesWordStudyLevelsLatestPerStudentR-CourseId}/word-study-levels/latest-per-student`.replace(`{${"CoursesWordStudyLevelsLatestPerStudentR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesWordStudyLevelsLatestPerStudentRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesWordStudyLevelsLatestPerStudentR200ResponseInnerFromJSON));
        });
    }
    /**
     * getCoursesWordStudyLevelsLatestPerStudentR
     */
    getCoursesWordStudyLevelsLatestPerStudentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCoursesWordStudyLevelsLatestPerStudentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getDemoDistrictsR
     */
    getDemoDistrictsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/demo-districts`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetExternalDemoDistrictsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getDemoDistrictsR
     */
    getDemoDistrictsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getDemoDistrictsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getDistrictSchoolsR
     */
    getDistrictSchoolsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling getDistrictSchoolsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/schools`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDistrictSchoolsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getDistrictSchoolsR
     */
    getDistrictSchoolsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getDistrictSchoolsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getDistrictsR
     */
    getDistrictsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetDistrictsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getDistrictsR
     */
    getDistrictsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getDistrictsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaAdaptiveSkillsAnswersR
     */
    getElaAdaptiveSkillsAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAdaptiveSkillsAnswersRElaAdaptiveSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaAdaptiveSkillsAnswersRElaAdaptiveSkillsPracticeAssignmentId', 'Required parameter "elaAdaptiveSkillsAnswersRElaAdaptiveSkillsPracticeAssignmentId" was null or undefined when calling getElaAdaptiveSkillsAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/adaptive-skills/{ElaAdaptiveSkillsAnswersR-ElaAdaptiveSkillsPracticeAssignmentId}/answers`.replace(`{${"ElaAdaptiveSkillsAnswersR-ElaAdaptiveSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaAdaptiveSkillsAnswersRElaAdaptiveSkillsPracticeAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaAdaptiveSkillsAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaAdaptiveSkillsAnswersR
     */
    getElaAdaptiveSkillsAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaAdaptiveSkillsAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaAdaptiveSkillsContentsR
     */
    getElaAdaptiveSkillsContentsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela/adaptive-skills/contents`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaAdaptiveSkillsContentsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaAdaptiveSkillsContentsR
     */
    getElaAdaptiveSkillsContentsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaAdaptiveSkillsContentsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaAdaptiveSkillsPassagesR
     */
    getElaAdaptiveSkillsPassagesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAdaptiveSkillsPassagesRElaAdaptiveSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaAdaptiveSkillsPassagesRElaAdaptiveSkillsPracticeAssignmentId', 'Required parameter "elaAdaptiveSkillsPassagesRElaAdaptiveSkillsPracticeAssignmentId" was null or undefined when calling getElaAdaptiveSkillsPassagesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/adaptive-skills/{ElaAdaptiveSkillsPassagesR-ElaAdaptiveSkillsPracticeAssignmentId}/passages`.replace(`{${"ElaAdaptiveSkillsPassagesR-ElaAdaptiveSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaAdaptiveSkillsPassagesRElaAdaptiveSkillsPracticeAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaAdaptiveSkillsPassagesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaAdaptiveSkillsPassagesR
     */
    getElaAdaptiveSkillsPassagesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaAdaptiveSkillsPassagesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaArticleReadingAnswersR
     */
    getElaArticleReadingAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId', 'Required parameter "elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId" was null or undefined when calling getElaArticleReadingAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/reading/{ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId}/answers`.replace(`{${"ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaArticleReadingAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaArticleReadingAnswersR
     */
    getElaArticleReadingAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaArticleReadingAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaArticleReadingAnswersRetriesR
     */
    getElaArticleReadingAnswersRetriesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId', 'Required parameter "elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId" was null or undefined when calling getElaArticleReadingAnswersRetriesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/reading/{ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId}/answers/retries`.replace(`{${"ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaArticleReadingAnswersRetriesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaArticleReadingAnswersRetriesR
     */
    getElaArticleReadingAnswersRetriesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaArticleReadingAnswersRetriesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaArticleSearchR
     */
    getElaArticleSearchRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela/article-search`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetElaArticleSearchR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getElaArticleSearchR
     */
    getElaArticleSearchR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaArticleSearchRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaArticleWritingAnswersR
     */
    getElaArticleWritingAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId', 'Required parameter "elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId" was null or undefined when calling getElaArticleWritingAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/writing/{ElaArticleWritingAssignmentP-NonEmptyElaArticleWritingAssignmentId}/answers`.replace(`{${"ElaArticleWritingAssignmentP-NonEmptyElaArticleWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaArticleWritingAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaArticleWritingAnswersR
     */
    getElaArticleWritingAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaArticleWritingAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaAssessmentAssignmentAnswersR
     */
    getElaAssessmentAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId'] == null) {
                throw new runtime.RequiredError('elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId', 'Required parameter "elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId" was null or undefined when calling getElaAssessmentAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/assessments/{ElaAssessmentAssignmentP-NonEmptyElaAssessmentAssignmentId}/answers`.replace(`{${"ElaAssessmentAssignmentP-NonEmptyElaAssessmentAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaAssessmentAssignmentAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaAssessmentAssignmentAnswersR
     */
    getElaAssessmentAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaAssessmentAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaAssessmentAssignmentReportR
     */
    getElaAssessmentAssignmentReportRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId'] == null) {
                throw new runtime.RequiredError('elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId', 'Required parameter "elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId" was null or undefined when calling getElaAssessmentAssignmentReportR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/assessments/{ElaAssessmentAssignmentP-NonEmptyElaAssessmentAssignmentId}/ela-assessment-report`.replace(`{${"ElaAssessmentAssignmentP-NonEmptyElaAssessmentAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetElaAssessmentAssignmentReportR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getElaAssessmentAssignmentReportR
     */
    getElaAssessmentAssignmentReportR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaAssessmentAssignmentReportRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaAssessmentSessionReportR
     */
    getElaAssessmentSessionReportRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAssessmentSessionReportRElaAssessmentAssignmentSessionId'] == null) {
                throw new runtime.RequiredError('elaAssessmentSessionReportRElaAssessmentAssignmentSessionId', 'Required parameter "elaAssessmentSessionReportRElaAssessmentAssignmentSessionId" was null or undefined when calling getElaAssessmentSessionReportR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assessment-session-report/{ElaAssessmentSessionReportR-ElaAssessmentAssignmentSessionId}`.replace(`{${"ElaAssessmentSessionReportR-ElaAssessmentAssignmentSessionId"}}`, encodeURIComponent(String(requestParameters['elaAssessmentSessionReportRElaAssessmentAssignmentSessionId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetElaAssessmentSessionReportR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getElaAssessmentSessionReportR
     */
    getElaAssessmentSessionReportR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaAssessmentSessionReportRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaClassActivityDetailR
     */
    getElaClassActivityDetailRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaClassActivityDetailRCourseId'] == null) {
                throw new runtime.RequiredError('elaClassActivityDetailRCourseId', 'Required parameter "elaClassActivityDetailRCourseId" was null or undefined when calling getElaClassActivityDetailR().');
            }
            if (requestParameters['elaClassActivityDetailRElaArticleId'] == null) {
                throw new runtime.RequiredError('elaClassActivityDetailRElaArticleId', 'Required parameter "elaClassActivityDetailRElaArticleId" was null or undefined when calling getElaClassActivityDetailR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{ElaClassActivityDetailR-CourseId}/ela-class-activity/{ElaClassActivityDetailR-ElaArticleId}`.replace(`{${"ElaClassActivityDetailR-CourseId"}}`, encodeURIComponent(String(requestParameters['elaClassActivityDetailRCourseId']))).replace(`{${"ElaClassActivityDetailR-ElaArticleId"}}`, encodeURIComponent(String(requestParameters['elaClassActivityDetailRElaArticleId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetElaClassActivityDetailR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getElaClassActivityDetailR
     */
    getElaClassActivityDetailR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaClassActivityDetailRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaClassActivityR
     */
    getElaClassActivityRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaClassActivityRCourseId'] == null) {
                throw new runtime.RequiredError('elaClassActivityRCourseId', 'Required parameter "elaClassActivityRCourseId" was null or undefined when calling getElaClassActivityR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{ElaClassActivityR-CourseId}/ela-class-activity`.replace(`{${"ElaClassActivityR-CourseId"}}`, encodeURIComponent(String(requestParameters['elaClassActivityRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaClassActivityR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaClassActivityR
     */
    getElaClassActivityR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaClassActivityRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaDecodablesAssignmentsR
     */
    getElaDecodablesAssignmentsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/decodables`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaDecodablesAssignmentsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaDecodablesAssignmentsR
     */
    getElaDecodablesAssignmentsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaDecodablesAssignmentsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaDecodablesHighestR
     */
    getElaDecodablesHighestRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela/decodables/highest`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetElaDecodablesHighestR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getElaDecodablesHighestR
     */
    getElaDecodablesHighestR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaDecodablesHighestRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaReadingLevelsR
     */
    getElaReadingLevelsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaReadingLevelsRCourseId'] == null) {
                throw new runtime.RequiredError('elaReadingLevelsRCourseId', 'Required parameter "elaReadingLevelsRCourseId" was null or undefined when calling getElaReadingLevelsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{ElaReadingLevelsR-CourseId}/ela-reading-levels`.replace(`{${"ElaReadingLevelsR-CourseId"}}`, encodeURIComponent(String(requestParameters['elaReadingLevelsRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaReadingLevelsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaReadingLevelsR
     */
    getElaReadingLevelsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaReadingLevelsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaSightWordsLevelR
     */
    getElaSightWordsLevelRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/sight-words-level`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetElaSightWordsLevelR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getElaSightWordsLevelR
     */
    getElaSightWordsLevelR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaSightWordsLevelRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaSightWordsR
     */
    getElaSightWordsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaSightWordsRElaSightWordsLevel'] == null) {
                throw new runtime.RequiredError('elaSightWordsRElaSightWordsLevel', 'Required parameter "elaSightWordsRElaSightWordsLevel" was null or undefined when calling getElaSightWordsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/sight-words/{ElaSightWordsR-ElaSightWordsLevel}`.replace(`{${"ElaSightWordsR-ElaSightWordsLevel"}}`, encodeURIComponent(String(requestParameters['elaSightWordsRElaSightWordsLevel']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaSightWordsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaSightWordsR
     */
    getElaSightWordsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaSightWordsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaSnapshotsR
     */
    getElaSnapshotsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-snapshots`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsElaSnapshotR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaSnapshotsR
     */
    getElaSnapshotsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaSnapshotsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaTargetedSkillsAnswersR
     */
    getElaTargetedSkillsAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId', 'Required parameter "elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId" was null or undefined when calling getElaTargetedSkillsAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/targeted-skills/{ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId}/answers`.replace(`{${"ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaTargetedSkillsAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaTargetedSkillsAnswersR
     */
    getElaTargetedSkillsAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaTargetedSkillsAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaTargetedSkillsPassagesR
     */
    getElaTargetedSkillsPassagesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId', 'Required parameter "elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId" was null or undefined when calling getElaTargetedSkillsPassagesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/targeted-skills/{ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId}/passages`.replace(`{${"ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaTargetedSkillsPassagesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaTargetedSkillsPassagesR
     */
    getElaTargetedSkillsPassagesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaTargetedSkillsPassagesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaVocabWordsR
     */
    getElaVocabWordsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaVocabWordsRNonEmptyVocabWord'] == null) {
                throw new runtime.RequiredError('elaVocabWordsRNonEmptyVocabWord', 'Required parameter "elaVocabWordsRNonEmptyVocabWord" was null or undefined when calling getElaVocabWordsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/vocab-words/{ElaVocabWordsR-NonEmptyVocabWord}`.replace(`{${"ElaVocabWordsR-NonEmptyVocabWord"}}`, encodeURIComponent(String(requestParameters['elaVocabWordsRNonEmptyVocabWord']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaVocabWordsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getElaVocabWordsR
     */
    getElaVocabWordsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaVocabWordsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getElaWordStudySessionsProgressR
     */
    getElaWordStudySessionsProgressRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/word-study/sessions/progress`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetElaWordStudySessionsProgressR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getElaWordStudySessionsProgressR
     */
    getElaWordStudySessionsProgressR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getElaWordStudySessionsProgressRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getEmailVerificationsR
     */
    getEmailVerificationsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/email-verifications`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getEmailVerificationsR
     */
    getEmailVerificationsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getEmailVerificationsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getExternalDemoDistrictsR
     */
    getExternalDemoDistrictsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/demo-districts/external`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetExternalDemoDistrictsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getExternalDemoDistrictsR
     */
    getExternalDemoDistrictsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getExternalDemoDistrictsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getHealthCheckR
     */
    getHealthCheckRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/health-check`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getHealthCheckR
     */
    getHealthCheckR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getHealthCheckRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getItemOwnershipsR
     */
    getItemOwnershipsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/item-ownerships`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostItemsItemOwnershipR200ResponseFromJSON));
        });
    }
    /**
     * getItemOwnershipsR
     */
    getItemOwnershipsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getItemOwnershipsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getItemsR
     */
    getItemsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/items`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetItemsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getItemsR
     */
    getItemsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getItemsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getLanguagesR
     */
    getLanguagesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/languages`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLanguagesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getLanguagesR
     */
    getLanguagesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLanguagesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getLicensesR
     */
    getLicensesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/licenses`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSchoolLicensesR200ResponseAnyOfInner1FromJSON));
        });
    }
    /**
     * getLicensesR
     */
    getLicensesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLicensesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getLoginCardsR
     */
    getLoginCardsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/login-cards`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetLoginCardsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getLoginCardsR
     */
    getLoginCardsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getLoginCardsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathAdaptiveAssignmentSessionAnswersR
     */
    getMathAdaptiveAssignmentSessionAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathAdaptiveAssignmentSessionAnswersRMathAdaptiveAssignmentSessionId'] == null) {
                throw new runtime.RequiredError('mathAdaptiveAssignmentSessionAnswersRMathAdaptiveAssignmentSessionId', 'Required parameter "mathAdaptiveAssignmentSessionAnswersRMathAdaptiveAssignmentSessionId" was null or undefined when calling getMathAdaptiveAssignmentSessionAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/assignment-sessions/adaptive/{MathAdaptiveAssignmentSessionAnswersR-MathAdaptiveAssignmentSessionId}/answers`.replace(`{${"MathAdaptiveAssignmentSessionAnswersR-MathAdaptiveAssignmentSessionId"}}`, encodeURIComponent(String(requestParameters['mathAdaptiveAssignmentSessionAnswersRMathAdaptiveAssignmentSessionId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetMathAdaptiveAssignmentSessionAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getMathAdaptiveAssignmentSessionAnswersR
     */
    getMathAdaptiveAssignmentSessionAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathAdaptiveAssignmentSessionAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathAssessmentByIdR
     */
    getMathAssessmentByIdRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathAssessmentByIdRMathAssessmentAssignmentId'] == null) {
                throw new runtime.RequiredError('mathAssessmentByIdRMathAssessmentAssignmentId', 'Required parameter "mathAssessmentByIdRMathAssessmentAssignmentId" was null or undefined when calling getMathAssessmentByIdR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assessments/{MathAssessmentByIdR-MathAssessmentAssignmentId}`.replace(`{${"MathAssessmentByIdR-MathAssessmentAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathAssessmentByIdRMathAssessmentAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetMathAssessmentByIdR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getMathAssessmentByIdR
     */
    getMathAssessmentByIdR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathAssessmentByIdRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathAssessmentSessionsAssessmentAnswersR
     */
    getMathAssessmentSessionsAssessmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathAssessmentSessionsAssessmentAnswersRMathAssessmentAssignmentSessionId'] == null) {
                throw new runtime.RequiredError('mathAssessmentSessionsAssessmentAnswersRMathAssessmentAssignmentSessionId', 'Required parameter "mathAssessmentSessionsAssessmentAnswersRMathAssessmentAssignmentSessionId" was null or undefined when calling getMathAssessmentSessionsAssessmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assessment-sessions/{MathAssessmentSessionsAssessmentAnswersR-MathAssessmentAssignmentSessionId}/assessment-answers`.replace(`{${"MathAssessmentSessionsAssessmentAnswersR-MathAssessmentAssignmentSessionId"}}`, encodeURIComponent(String(requestParameters['mathAssessmentSessionsAssessmentAnswersRMathAssessmentAssignmentSessionId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetMathAssessmentsAssessmentAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getMathAssessmentSessionsAssessmentAnswersR
     */
    getMathAssessmentSessionsAssessmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathAssessmentSessionsAssessmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathAssessmentsAssessmentAnswersR
     */
    getMathAssessmentsAssessmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathAssessmentsAssessmentAnswersRMathAssessmentAssignmentId'] == null) {
                throw new runtime.RequiredError('mathAssessmentsAssessmentAnswersRMathAssessmentAssignmentId', 'Required parameter "mathAssessmentsAssessmentAnswersRMathAssessmentAssignmentId" was null or undefined when calling getMathAssessmentsAssessmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assessments/{MathAssessmentsAssessmentAnswersR-MathAssessmentAssignmentId}/assessment-answers`.replace(`{${"MathAssessmentsAssessmentAnswersR-MathAssessmentAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathAssessmentsAssessmentAnswersRMathAssessmentAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetMathAssessmentsAssessmentAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getMathAssessmentsAssessmentAnswersR
     */
    getMathAssessmentsAssessmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathAssessmentsAssessmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathAssignmentsAssignmentSessionsIsAnySessionCompleteR
     */
    getMathAssignmentsAssignmentSessionsIsAnySessionCompleteRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assignments/assignment-sessions/is-any-session-complete`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetMathAssignmentsAssignmentSessionsIsAnySessionCompleteR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getMathAssignmentsAssignmentSessionsIsAnySessionCompleteR
     */
    getMathAssignmentsAssignmentSessionsIsAnySessionCompleteR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathAssignmentsAssignmentSessionsIsAnySessionCompleteRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathFactPracticeSnapshotsLatest3R
     */
    getMathFactPracticeSnapshotsLatest3RRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-fact-practice-snapshots/latest3`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetMathFactPracticeSnapshotsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getMathFactPracticeSnapshotsLatest3R
     */
    getMathFactPracticeSnapshotsLatest3R(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathFactPracticeSnapshotsLatest3RRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathFactPracticeSnapshotsR
     */
    getMathFactPracticeSnapshotsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-fact-practice-snapshots/latest`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetMathFactPracticeSnapshotsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getMathFactPracticeSnapshotsR
     */
    getMathFactPracticeSnapshotsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathFactPracticeSnapshotsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathFactPracticeUsageR
     */
    getMathFactPracticeUsageRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-fact-practice-usage`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetMathFactPracticeUsageR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getMathFactPracticeUsageR
     */
    getMathFactPracticeUsageR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathFactPracticeUsageRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathStandardAssignmentQuestionsR
     */
    getMathStandardAssignmentQuestionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathStandardAssignmentsPNonEmptyMathStandardAssignmentId'] == null) {
                throw new runtime.RequiredError('mathStandardAssignmentsPNonEmptyMathStandardAssignmentId', 'Required parameter "mathStandardAssignmentsPNonEmptyMathStandardAssignmentId" was null or undefined when calling getMathStandardAssignmentQuestionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assignments/standard/{MathStandardAssignmentsP-NonEmptyMathStandardAssignmentId}/questions`.replace(`{${"MathStandardAssignmentsP-NonEmptyMathStandardAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathStandardAssignmentsPNonEmptyMathStandardAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetMathStandardAssignmentQuestionsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getMathStandardAssignmentQuestionsR
     */
    getMathStandardAssignmentQuestionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathStandardAssignmentQuestionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getMathTargetedAssignmentSessionsAnswersR
     */
    getMathTargetedAssignmentSessionsAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathTargetedAssignmentSessionsAnswersRMathStandardAssignmentSessionId'] == null) {
                throw new runtime.RequiredError('mathTargetedAssignmentSessionsAnswersRMathStandardAssignmentSessionId', 'Required parameter "mathTargetedAssignmentSessionsAnswersRMathStandardAssignmentSessionId" was null or undefined when calling getMathTargetedAssignmentSessionsAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-targeted-assignment-sessions/{MathTargetedAssignmentSessionsAnswersR-MathStandardAssignmentSessionId}/answers`.replace(`{${"MathTargetedAssignmentSessionsAnswersR-MathStandardAssignmentSessionId"}}`, encodeURIComponent(String(requestParameters['mathTargetedAssignmentSessionsAnswersRMathStandardAssignmentSessionId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetMathTargetedAssignmentSessionsAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getMathTargetedAssignmentSessionsAnswersR
     */
    getMathTargetedAssignmentSessionsAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getMathTargetedAssignmentSessionsAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getNumberFactsLevelsR
     */
    getNumberFactsLevelsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math/number-facts/levels`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetNumberFactsLevelsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getNumberFactsLevelsR
     */
    getNumberFactsLevelsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getNumberFactsLevelsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getNumberFactsQuestionsR
     */
    getNumberFactsQuestionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math/number-facts/questions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetNumberFactsQuestionsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getNumberFactsQuestionsR
     */
    getNumberFactsQuestionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getNumberFactsQuestionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getOperationR
     */
    getOperationRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['operationPOperationId'] == null) {
                throw new runtime.RequiredError('operationPOperationId', 'Required parameter "operationPOperationId" was null or undefined when calling getOperationR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/operations/{OperationP-OperationId}`.replace(`{${"OperationP-OperationId"}}`, encodeURIComponent(String(requestParameters['operationPOperationId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetOperationR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getOperationR
     */
    getOperationR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOperationRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getPeriscopeEmbedsDistrictGrowthR
     */
    getPeriscopeEmbedsDistrictGrowthRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/periscope-embeds/districts/growth`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetPeriscopeEmbedsSchoolUsageR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getPeriscopeEmbedsDistrictGrowthR
     */
    getPeriscopeEmbedsDistrictGrowthR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPeriscopeEmbedsDistrictGrowthRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getPeriscopeEmbedsSchoolGrowthR
     */
    getPeriscopeEmbedsSchoolGrowthRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['periscopeEmbedsSchoolGrowthRSchoolId'] == null) {
                throw new runtime.RequiredError('periscopeEmbedsSchoolGrowthRSchoolId', 'Required parameter "periscopeEmbedsSchoolGrowthRSchoolId" was null or undefined when calling getPeriscopeEmbedsSchoolGrowthR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/periscope-embeds/schools/{PeriscopeEmbedsSchoolGrowthR-SchoolId}/growth`.replace(`{${"PeriscopeEmbedsSchoolGrowthR-SchoolId"}}`, encodeURIComponent(String(requestParameters['periscopeEmbedsSchoolGrowthRSchoolId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetPeriscopeEmbedsSchoolUsageR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getPeriscopeEmbedsSchoolGrowthR
     */
    getPeriscopeEmbedsSchoolGrowthR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPeriscopeEmbedsSchoolGrowthRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getPeriscopeEmbedsSchoolUsageR
     */
    getPeriscopeEmbedsSchoolUsageRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/periscope-embeds/school-usage`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetPeriscopeEmbedsSchoolUsageR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getPeriscopeEmbedsSchoolUsageR
     */
    getPeriscopeEmbedsSchoolUsageR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPeriscopeEmbedsSchoolUsageRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getPeriscopeEmbedsSkillDetailsR
     */
    getPeriscopeEmbedsSkillDetailsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['periscopeEmbedsSkillDetailsRUspId'] == null) {
                throw new runtime.RequiredError('periscopeEmbedsSkillDetailsRUspId', 'Required parameter "periscopeEmbedsSkillDetailsRUspId" was null or undefined when calling getPeriscopeEmbedsSkillDetailsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/periscope-embeds/skill-details/{PeriscopeEmbedsSkillDetailsR-UspId}`.replace(`{${"PeriscopeEmbedsSkillDetailsR-UspId"}}`, encodeURIComponent(String(requestParameters['periscopeEmbedsSkillDetailsRUspId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetPeriscopeEmbedsSchoolUsageR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getPeriscopeEmbedsSkillDetailsR
     */
    getPeriscopeEmbedsSkillDetailsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPeriscopeEmbedsSkillDetailsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getPeriscopeEmbedsStudentGrowthR
     */
    getPeriscopeEmbedsStudentGrowthRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['periscopeEmbedsStudentGrowthRStudentId'] == null) {
                throw new runtime.RequiredError('periscopeEmbedsStudentGrowthRStudentId', 'Required parameter "periscopeEmbedsStudentGrowthRStudentId" was null or undefined when calling getPeriscopeEmbedsStudentGrowthR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/periscope-embeds/students/{PeriscopeEmbedsStudentGrowthR-StudentId}/growth`.replace(`{${"PeriscopeEmbedsStudentGrowthR-StudentId"}}`, encodeURIComponent(String(requestParameters['periscopeEmbedsStudentGrowthRStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetPeriscopeEmbedsSchoolUsageR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getPeriscopeEmbedsStudentGrowthR
     */
    getPeriscopeEmbedsStudentGrowthR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPeriscopeEmbedsStudentGrowthRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getPeriscopeEmbedsTeacherGrowthR
     */
    getPeriscopeEmbedsTeacherGrowthRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['periscopeEmbedsTeacherGrowthRTeacherId'] == null) {
                throw new runtime.RequiredError('periscopeEmbedsTeacherGrowthRTeacherId', 'Required parameter "periscopeEmbedsTeacherGrowthRTeacherId" was null or undefined when calling getPeriscopeEmbedsTeacherGrowthR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/periscope-embeds/teachers/{PeriscopeEmbedsTeacherGrowthR-TeacherId}/growth`.replace(`{${"PeriscopeEmbedsTeacherGrowthR-TeacherId"}}`, encodeURIComponent(String(requestParameters['periscopeEmbedsTeacherGrowthRTeacherId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetPeriscopeEmbedsSchoolUsageR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getPeriscopeEmbedsTeacherGrowthR
     */
    getPeriscopeEmbedsTeacherGrowthR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPeriscopeEmbedsTeacherGrowthRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getPingR
     */
    getPingRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ping`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getPingR
     */
    getPingR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPingRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getPremiumLicensesR
     */
    getPremiumLicensesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/premium-licenses`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetPremiumLicensesR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getPremiumLicensesR
     */
    getPremiumLicensesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getPremiumLicensesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getReferralsR
     */
    getReferralsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/referrals`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetReferralsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getReferralsR
     */
    getReferralsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getReferralsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getRostersR
     */
    getRostersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling getRostersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/rosters`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetRostersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getRostersR
     */
    getRostersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRostersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getRoutesR
     */
    getRoutesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/routes.js`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getRoutesR
     */
    getRoutesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getRoutesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolAdminsMeDashboardR
     */
    getSchoolAdminsMeDashboardRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/me/dashboard`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolAdminsMeDashboardR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getSchoolAdminsMeDashboardR
     */
    getSchoolAdminsMeDashboardR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolAdminsMeDashboardRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolAdminsMeR
     */
    getSchoolAdminsMeRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/me`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolAdminsMeR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getSchoolAdminsMeR
     */
    getSchoolAdminsMeR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolAdminsMeRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolAdminsMeTeachersMissingEmailsCsvR
     */
    getSchoolAdminsMeTeachersMissingEmailsCsvRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/me/teachers-missing-emails`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSchoolAdminsMeTeachersMissingEmailsCsvR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSchoolAdminsMeTeachersMissingEmailsCsvR
     */
    getSchoolAdminsMeTeachersMissingEmailsCsvR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolAdminsMeTeachersMissingEmailsCsvRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolAdminsMeTeachersR
     */
    getSchoolAdminsMeTeachersRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/me/teachers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsTeachersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSchoolAdminsMeTeachersR
     */
    getSchoolAdminsMeTeachersR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolAdminsMeTeachersRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolAdminsR
     */
    getSchoolAdminsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSchoolAdminsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSchoolAdminsR
     */
    getSchoolAdminsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolAdminsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolAdminsSessionsR
     */
    getSchoolAdminsSessionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/sessions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetTeachersSessionsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getSchoolAdminsSessionsR
     */
    getSchoolAdminsSessionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolAdminsSessionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolAssessments2R
     */
    getSchoolAssessments2RRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling getSchoolAssessments2R().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/assessments2`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSchoolAssessments2R200ResponseInnerFromJSON));
        });
    }
    /**
     * getSchoolAssessments2R
     */
    getSchoolAssessments2R(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolAssessments2RRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolColleaguesR
     */
    getSchoolColleaguesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling getSchoolColleaguesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/colleagues`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSchoolColleaguesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSchoolColleaguesR
     */
    getSchoolColleaguesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolColleaguesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolCoursesR
     */
    getSchoolCoursesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling getSchoolCoursesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/courses`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCoursesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSchoolCoursesR
     */
    getSchoolCoursesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolCoursesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolDeletionInfoR
     */
    getSchoolDeletionInfoRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling getSchoolDeletionInfoR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/deletion-info`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolDeletionInfoR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getSchoolDeletionInfoR
     */
    getSchoolDeletionInfoR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolDeletionInfoRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolLicensesR
     */
    getSchoolLicensesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling getSchoolLicensesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/licenses`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolLicensesR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getSchoolLicensesR
     */
    getSchoolLicensesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolLicensesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolMathAssessmentsAssignmentAnswersR
     */
    getSchoolMathAssessmentsAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling getSchoolMathAssessmentsAssignmentAnswersR().');
            }
            if (requestParameters['schoolMathAssessmentsAssignmentPMathAssessmentAssignmentId'] == null) {
                throw new runtime.RequiredError('schoolMathAssessmentsAssignmentPMathAssessmentAssignmentId', 'Required parameter "schoolMathAssessmentsAssignmentPMathAssessmentAssignmentId" was null or undefined when calling getSchoolMathAssessmentsAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/math/assessments/assignments/{SchoolMathAssessmentsAssignmentP-MathAssessmentAssignmentId}/answers`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))).replace(`{${"SchoolMathAssessmentsAssignmentP-MathAssessmentAssignmentId"}}`, encodeURIComponent(String(requestParameters['schoolMathAssessmentsAssignmentPMathAssessmentAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetMathAssessmentsAssessmentAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSchoolMathAssessmentsAssignmentAnswersR
     */
    getSchoolMathAssessmentsAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolMathAssessmentsAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolMathStandardSetR
     */
    getSchoolMathStandardSetRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3SchoolPSchoolId'] == null) {
                throw new runtime.RequiredError('v3SchoolPSchoolId', 'Required parameter "v3SchoolPSchoolId" was null or undefined when calling getSchoolMathStandardSetR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/schools/{V3SchoolP-SchoolId}/math/standard-set`.replace(`{${"V3SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['v3SchoolPSchoolId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSelfStudentR200ResponseElaStandardSetFromJSON(jsonValue));
        });
    }
    /**
     * getSchoolMathStandardSetR
     */
    getSchoolMathStandardSetR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolMathStandardSetRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolR
     */
    getSchoolRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling getSchoolR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * getSchoolR
     */
    getSchoolR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolSubjectProductSessionsR
     */
    getSchoolSubjectProductSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3SchoolPSchoolId'] == null) {
                throw new runtime.RequiredError('v3SchoolPSchoolId', 'Required parameter "v3SchoolPSchoolId" was null or undefined when calling getSchoolSubjectProductSessionsR().');
            }
            if (requestParameters['schoolSubjectPSubject'] == null) {
                throw new runtime.RequiredError('schoolSubjectPSubject', 'Required parameter "schoolSubjectPSubject" was null or undefined when calling getSchoolSubjectProductSessionsR().');
            }
            if (requestParameters['schoolProductPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('schoolProductPAbbreviatedProduct', 'Required parameter "schoolProductPAbbreviatedProduct" was null or undefined when calling getSchoolSubjectProductSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/schools/{V3SchoolP-SchoolId}/subjects/{SchoolSubjectP-Subject}/products/{SchoolProductP-AbbreviatedProduct}/sessions`.replace(`{${"V3SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['v3SchoolPSchoolId']))).replace(`{${"SchoolSubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['schoolSubjectPSubject']))).replace(`{${"SchoolProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['schoolProductPAbbreviatedProduct']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSubjectProductSessionsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSchoolSubjectProductSessionsR
     */
    getSchoolSubjectProductSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolSubjectProductSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolsR
     */
    getSchoolsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSchoolsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSchoolsR
     */
    getSchoolsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSchoolsSearchR
     */
    getSchoolsSearchRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/search`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolsSearchR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getSchoolsSearchR
     */
    getSchoolsSearchR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSchoolsSearchRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getScienceReadingAssignmentAnswersR
     */
    getScienceReadingAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId', 'Required parameter "scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId" was null or undefined when calling getScienceReadingAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/reading/{ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId}/answers`.replace(`{${"ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaArticleReadingAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getScienceReadingAssignmentAnswersR
     */
    getScienceReadingAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScienceReadingAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getScienceReadingAssignmentAnswersRetriesR
     */
    getScienceReadingAssignmentAnswersRetriesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId', 'Required parameter "scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId" was null or undefined when calling getScienceReadingAssignmentAnswersRetriesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/reading/{ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId}/answers/retries`.replace(`{${"ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaArticleReadingAnswersRetriesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getScienceReadingAssignmentAnswersRetriesR
     */
    getScienceReadingAssignmentAnswersRetriesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScienceReadingAssignmentAnswersRetriesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getScienceWritingAssignmentAnswersR
     */
    getScienceWritingAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId', 'Required parameter "scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId" was null or undefined when calling getScienceWritingAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/writing/{ScienceWritingAssignmentP-NonEmptyScienceWritingAssignmentId}/answers`.replace(`{${"ScienceWritingAssignmentP-NonEmptyScienceWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSocialStudiesWritingAssignmentAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getScienceWritingAssignmentAnswersR
     */
    getScienceWritingAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getScienceWritingAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSelfStudentR
     */
    getSelfStudentRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/me`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSelfStudentR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getSelfStudentR
     */
    getSelfStudentR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSelfStudentRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSlothR
     */
    getSlothRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/sloth`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getSlothR
     */
    getSlothR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSlothRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSocialStudiesReadingAssignmentAnswersR
     */
    getSocialStudiesReadingAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId', 'Required parameter "socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId" was null or undefined when calling getSocialStudiesReadingAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/reading/{SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId}/answers`.replace(`{${"SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaArticleReadingAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSocialStudiesReadingAssignmentAnswersR
     */
    getSocialStudiesReadingAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSocialStudiesReadingAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSocialStudiesReadingAssignmentAnswersRetriesR
     */
    getSocialStudiesReadingAssignmentAnswersRetriesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId', 'Required parameter "socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId" was null or undefined when calling getSocialStudiesReadingAssignmentAnswersRetriesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/reading/{SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId}/answers/retries`.replace(`{${"SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaArticleReadingAnswersRetriesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSocialStudiesReadingAssignmentAnswersRetriesR
     */
    getSocialStudiesReadingAssignmentAnswersRetriesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSocialStudiesReadingAssignmentAnswersRetriesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSocialStudiesWritingAssignmentAnswersR
     */
    getSocialStudiesWritingAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId', 'Required parameter "socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId" was null or undefined when calling getSocialStudiesWritingAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/writing/{SocialStudiesWritingAssignmentP-NonEmptySocialStudiesWritingAssignmentId}/answers`.replace(`{${"SocialStudiesWritingAssignmentP-NonEmptySocialStudiesWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSocialStudiesWritingAssignmentAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSocialStudiesWritingAssignmentAnswersR
     */
    getSocialStudiesWritingAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSocialStudiesWritingAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentHighlightsForCourseR
     */
    getStudentHighlightsForCourseRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentHighlightsForCourseRCourseId'] == null) {
                throw new runtime.RequiredError('studentHighlightsForCourseRCourseId', 'Required parameter "studentHighlightsForCourseRCourseId" was null or undefined when calling getStudentHighlightsForCourseR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{StudentHighlightsForCourseR-CourseId}/student-highlights`.replace(`{${"StudentHighlightsForCourseR-CourseId"}}`, encodeURIComponent(String(requestParameters['studentHighlightsForCourseRCourseId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentHighlightsForCourseR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getStudentHighlightsForCourseR
     */
    getStudentHighlightsForCourseR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentHighlightsForCourseRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentMathAdaptiveRewardsR
     */
    getStudentMathAdaptiveRewardsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3StudentPStudentId'] == null) {
                throw new runtime.RequiredError('v3StudentPStudentId', 'Required parameter "v3StudentPStudentId" was null or undefined when calling getStudentMathAdaptiveRewardsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/{V3StudentP-StudentId}/math/adaptive/rewards`.replace(`{${"V3StudentP-StudentId"}}`, encodeURIComponent(String(requestParameters['v3StudentPStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentMathAdaptiveRewardsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentMathAdaptiveRewardsR
     */
    getStudentMathAdaptiveRewardsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentMathAdaptiveRewardsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentMathAdaptiveStatsStudentDomainMonthLatestR
     */
    getStudentMathAdaptiveStatsStudentDomainMonthLatestRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/me/math-adaptive-stats-student-domain-month/latest`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentMathAdaptiveStatsStudentDomainMonthLatestR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentMathAdaptiveStatsStudentDomainMonthLatestR
     */
    getStudentMathAdaptiveStatsStudentDomainMonthLatestR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentMathAdaptiveStatsStudentDomainMonthLatestRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentMathDomainStatusesR
     */
    getStudentMathDomainStatusesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3StudentPStudentId'] == null) {
                throw new runtime.RequiredError('v3StudentPStudentId', 'Required parameter "v3StudentPStudentId" was null or undefined when calling getStudentMathDomainStatusesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/{V3StudentP-StudentId}/math/domain-statuses`.replace(`{${"V3StudentP-StudentId"}}`, encodeURIComponent(String(requestParameters['v3StudentPStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentMathDomainStatusesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentMathDomainStatusesR
     */
    getStudentMathDomainStatusesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentMathDomainStatusesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentMathProgressR
     */
    getStudentMathProgressRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3StudentPStudentId'] == null) {
                throw new runtime.RequiredError('v3StudentPStudentId', 'Required parameter "v3StudentPStudentId" was null or undefined when calling getStudentMathProgressR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/{V3StudentP-StudentId}/math/progress`.replace(`{${"V3StudentP-StudentId"}}`, encodeURIComponent(String(requestParameters['v3StudentPStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentMathProgressR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentMathProgressR
     */
    getStudentMathProgressR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentMathProgressRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentMathReportCardR
     */
    getStudentMathReportCardRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3StudentPStudentId'] == null) {
                throw new runtime.RequiredError('v3StudentPStudentId', 'Required parameter "v3StudentPStudentId" was null or undefined when calling getStudentMathReportCardR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/{V3StudentP-StudentId}/math/report-card`.replace(`{${"V3StudentP-StudentId"}}`, encodeURIComponent(String(requestParameters['v3StudentPStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentMathReportCardR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getStudentMathReportCardR
     */
    getStudentMathReportCardR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentMathReportCardRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentMathSuggestedDomainR
     */
    getStudentMathSuggestedDomainRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3StudentPStudentId'] == null) {
                throw new runtime.RequiredError('v3StudentPStudentId', 'Required parameter "v3StudentPStudentId" was null or undefined when calling getStudentMathSuggestedDomainR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/{V3StudentP-StudentId}/math/suggested-domain`.replace(`{${"V3StudentP-StudentId"}}`, encodeURIComponent(String(requestParameters['v3StudentPStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentMathAdaptiveStatsStudentDomainMonthLatestR200ResponseInnerDomainFromJSON(jsonValue));
        });
    }
    /**
     * getStudentMathSuggestedDomainR
     */
    getStudentMathSuggestedDomainR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentMathSuggestedDomainRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentPingR
     */
    getStudentPingRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/student-ping`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getStudentPingR
     */
    getStudentPingR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentPingRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentStandardStatsR
     */
    getStudentStandardStatsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentStandardStatsRStudentId'] == null) {
                throw new runtime.RequiredError('studentStandardStatsRStudentId', 'Required parameter "studentStandardStatsRStudentId" was null or undefined when calling getStudentStandardStatsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentStandardStatsR-StudentId}/standard-stats`.replace(`{${"StudentStandardStatsR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentStandardStatsRStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentStandardStatsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentStandardStatsR
     */
    getStudentStandardStatsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentStandardStatsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsCoTeachersR
     */
    getStudentsCoTeachersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentsCoTeachersRNonEmptyStudentId'] == null) {
                throw new runtime.RequiredError('studentsCoTeachersRNonEmptyStudentId', 'Required parameter "studentsCoTeachersRNonEmptyStudentId" was null or undefined when calling getStudentsCoTeachersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentsCoTeachersR-NonEmptyStudentId}/co-teachers`.replace(`{${"StudentsCoTeachersR-NonEmptyStudentId"}}`, encodeURIComponent(String(requestParameters['studentsCoTeachersRNonEmptyStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsCoTeachersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsCoTeachersR
     */
    getStudentsCoTeachersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsCoTeachersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsDuplicatesR
     */
    getStudentsDuplicatesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/duplicates`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsDuplicatesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsDuplicatesR
     */
    getStudentsDuplicatesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsDuplicatesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsElaProgressR
     */
    getStudentsElaProgressRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/me/ela-progress`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsElaProgressR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getStudentsElaProgressR
     */
    getStudentsElaProgressR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsElaProgressRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsElaReportCardR
     */
    getStudentsElaReportCardRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentsElaReportCardRStudentId'] == null) {
                throw new runtime.RequiredError('studentsElaReportCardRStudentId', 'Required parameter "studentsElaReportCardRStudentId" was null or undefined when calling getStudentsElaReportCardR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentsElaReportCardR-StudentId}/ela-report-card`.replace(`{${"StudentsElaReportCardR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentsElaReportCardRStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsElaReportCardR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getStudentsElaReportCardR
     */
    getStudentsElaReportCardR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsElaReportCardRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsElaSnapshotR
     */
    getStudentsElaSnapshotRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/me/ela-snapshots/latest`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsElaSnapshotR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsElaSnapshotR
     */
    getStudentsElaSnapshotR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsElaSnapshotRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsGoalsR
     */
    getStudentsGoalsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['goalsPStudentId'] == null) {
                throw new runtime.RequiredError('goalsPStudentId', 'Required parameter "goalsPStudentId" was null or undefined when calling getStudentsGoalsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{GoalsP-StudentId}/goals`.replace(`{${"GoalsP-StudentId"}}`, encodeURIComponent(String(requestParameters['goalsPStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsGoalsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsGoalsR
     */
    getStudentsGoalsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsGoalsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsIdpOverlaysR
     */
    getStudentsIdpOverlaysRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/student-idp-overlays`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsIdpOverlaysR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsIdpOverlaysR
     */
    getStudentsIdpOverlaysR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsIdpOverlaysRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsIncompleteAssignmentCountR
     */
    getStudentsIncompleteAssignmentCountRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/me/incomplete-assignment-count`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsIncompleteAssignmentCountR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getStudentsIncompleteAssignmentCountR
     */
    getStudentsIncompleteAssignmentCountR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsIncompleteAssignmentCountRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsLoginEventsR
     */
    getStudentsLoginEventsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/me/login-events`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsLoginEventsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsLoginEventsR
     */
    getStudentsLoginEventsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsLoginEventsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsMathNumberBasicsSnapshotsLatestR
     */
    getStudentsMathNumberBasicsSnapshotsLatestRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentsMathNumberBasicsSnapshotsLatestRStudentId'] == null) {
                throw new runtime.RequiredError('studentsMathNumberBasicsSnapshotsLatestRStudentId', 'Required parameter "studentsMathNumberBasicsSnapshotsLatestRStudentId" was null or undefined when calling getStudentsMathNumberBasicsSnapshotsLatestR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentsMathNumberBasicsSnapshotsLatestR-StudentId}/math/number-basics/snapshots/latest`.replace(`{${"StudentsMathNumberBasicsSnapshotsLatestR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentsMathNumberBasicsSnapshotsLatestRStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsMathNumberBasicsSnapshotsLatestR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getStudentsMathNumberBasicsSnapshotsLatestR
     */
    getStudentsMathNumberBasicsSnapshotsLatestR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsMathNumberBasicsSnapshotsLatestRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsMeMathAdaptivePretestStatusR
     */
    getStudentsMeMathAdaptivePretestStatusRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/me/math-adaptive-pretest-status`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsMeMathAdaptivePretestStatusR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getStudentsMeMathAdaptivePretestStatusR
     */
    getStudentsMeMathAdaptivePretestStatusR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsMeMathAdaptivePretestStatusRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsProgressAndGrowthR
     */
    getStudentsProgressAndGrowthRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/me/progress-and-growth`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsProgressAndGrowthR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsProgressAndGrowthR
     */
    getStudentsProgressAndGrowthR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsProgressAndGrowthRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsR
     */
    getStudentsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsR
     */
    getStudentsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsSharesR
     */
    getStudentsSharesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/student-shares`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsSharesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsSharesR
     */
    getStudentsSharesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsSharesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsTeachersR
     */
    getStudentsTeachersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentsTeachersRStudentId'] == null) {
                throw new runtime.RequiredError('studentsTeachersRStudentId', 'Required parameter "studentsTeachersRStudentId" was null or undefined when calling getStudentsTeachersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentsTeachersR-StudentId}/teachers`.replace(`{${"StudentsTeachersR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentsTeachersRStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsTeachersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getStudentsTeachersR
     */
    getStudentsTeachersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsTeachersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getStudentsTimeSpentR
     */
    getStudentsTimeSpentRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/me/time-spent`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsTimeSpentR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getStudentsTimeSpentR
     */
    getStudentsTimeSpentR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getStudentsTimeSpentRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSubjectAcademicVocabularyR
     */
    getSubjectAcademicVocabularyRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling getSubjectAcademicVocabularyR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/academic-vocabulary`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSubjectAcademicVocabularyR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSubjectAcademicVocabularyR
     */
    getSubjectAcademicVocabularyR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubjectAcademicVocabularyRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSubjectProductAssignmentPassagesR
     */
    getSubjectProductAssignmentPassagesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling getSubjectProductAssignmentPassagesR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling getSubjectProductAssignmentPassagesR().');
            }
            if (requestParameters['subjectProductAssignmentPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductAssignmentPInt64', 'Required parameter "subjectProductAssignmentPInt64" was null or undefined when calling getSubjectProductAssignmentPassagesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/assignments/{SubjectProductAssignmentP-Int64}/passages`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductAssignmentP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductAssignmentPInt64']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetElaTargetedSkillsPassagesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSubjectProductAssignmentPassagesR
     */
    getSubjectProductAssignmentPassagesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubjectProductAssignmentPassagesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSubjectProductSessionAnswersR
     */
    getSubjectProductSessionAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling getSubjectProductSessionAnswersR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling getSubjectProductSessionAnswersR().');
            }
            if (requestParameters['subjectProductSessionPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductSessionPInt64', 'Required parameter "subjectProductSessionPInt64" was null or undefined when calling getSubjectProductSessionAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions/{SubjectProductSessionP-Int64}/answers`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductSessionP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionPInt64']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSubjectProductSessionAnswersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSubjectProductSessionAnswersR
     */
    getSubjectProductSessionAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubjectProductSessionAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSubjectProductSessionAttemptsR
     */
    getSubjectProductSessionAttemptsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling getSubjectProductSessionAttemptsR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling getSubjectProductSessionAttemptsR().');
            }
            if (requestParameters['subjectProductSessionPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductSessionPInt64', 'Required parameter "subjectProductSessionPInt64" was null or undefined when calling getSubjectProductSessionAttemptsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions/{SubjectProductSessionP-Int64}/attempts`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductSessionP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionPInt64']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * getSubjectProductSessionAttemptsR
     */
    getSubjectProductSessionAttemptsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubjectProductSessionAttemptsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSubjectProductSessionR
     */
    getSubjectProductSessionRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling getSubjectProductSessionR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling getSubjectProductSessionR().');
            }
            if (requestParameters['subjectProductSessionPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductSessionPInt64', 'Required parameter "subjectProductSessionPInt64" was null or undefined when calling getSubjectProductSessionR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions/{SubjectProductSessionP-Int64}`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductSessionP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionPInt64']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSubjectProductSessionsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * getSubjectProductSessionR
     */
    getSubjectProductSessionR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubjectProductSessionRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getSubjectProductSessionsR
     */
    getSubjectProductSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling getSubjectProductSessionsR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling getSubjectProductSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSubjectProductSessionsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getSubjectProductSessionsR
     */
    getSubjectProductSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSubjectProductSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getTeacherClaimedFreeResourcesR
     */
    getTeacherClaimedFreeResourcesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teacherClaimedFreeResourcesPTeacherId'] == null) {
                throw new runtime.RequiredError('teacherClaimedFreeResourcesPTeacherId', 'Required parameter "teacherClaimedFreeResourcesPTeacherId" was null or undefined when calling getTeacherClaimedFreeResourcesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeacherClaimedFreeResourcesP-TeacherId}/claimed-free-resources`.replace(`{${"TeacherClaimedFreeResourcesP-TeacherId"}}`, encodeURIComponent(String(requestParameters['teacherClaimedFreeResourcesPTeacherId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetTeacherClaimedFreeResourcesR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getTeacherClaimedFreeResourcesR
     */
    getTeacherClaimedFreeResourcesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTeacherClaimedFreeResourcesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getTeacherCoursesDefaultR
     */
    getTeacherCoursesDefaultRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teacherCoursesDefaultRTeacherId'] == null) {
                throw new runtime.RequiredError('teacherCoursesDefaultRTeacherId', 'Required parameter "teacherCoursesDefaultRTeacherId" was null or undefined when calling getTeacherCoursesDefaultR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeacherCoursesDefaultR-TeacherId}/courses/default`.replace(`{${"TeacherCoursesDefaultR-TeacherId"}}`, encodeURIComponent(String(requestParameters['teacherCoursesDefaultRTeacherId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCoursesR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * getTeacherCoursesDefaultR
     */
    getTeacherCoursesDefaultR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTeacherCoursesDefaultRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getTeacherLicenseAllocationsR
     */
    getTeacherLicenseAllocationsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teacherLicenseAllocationsRTeacherId'] == null) {
                throw new runtime.RequiredError('teacherLicenseAllocationsRTeacherId', 'Required parameter "teacherLicenseAllocationsRTeacherId" was null or undefined when calling getTeacherLicenseAllocationsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeacherLicenseAllocationsR-TeacherId}/license-allocations`.replace(`{${"TeacherLicenseAllocationsR-TeacherId"}}`, encodeURIComponent(String(requestParameters['teacherLicenseAllocationsRTeacherId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTeacherLicenseAllocationsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getTeacherLicenseAllocationsR
     */
    getTeacherLicenseAllocationsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTeacherLicenseAllocationsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getTeacherPingR
     */
    getTeacherPingRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teacher-ping`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * getTeacherPingR
     */
    getTeacherPingR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTeacherPingRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getTeachersMeR
     */
    getTeachersMeRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/me`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetTeachersMeR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getTeachersMeR
     */
    getTeachersMeR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTeachersMeRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getTeachersR
     */
    getTeachersRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetTeachersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getTeachersR
     */
    getTeachersR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTeachersRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getTeachersSessionsR
     */
    getTeachersSessionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/sessions`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetTeachersSessionsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getTeachersSessionsR
     */
    getTeachersSessionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getTeachersSessionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getV3CoursesR
     */
    getV3CoursesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetV3CoursesR200ResponseInnerFromJSON));
        });
    }
    /**
     * getV3CoursesR
     */
    getV3CoursesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getV3CoursesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getV3StudentPracticeSummaryR
     */
    getV3StudentPracticeSummaryRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3StudentPStudentId'] == null) {
                throw new runtime.RequiredError('v3StudentPStudentId', 'Required parameter "v3StudentPStudentId" was null or undefined when calling getV3StudentPracticeSummaryR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/{V3StudentP-StudentId}/practice-summary`.replace(`{${"V3StudentP-StudentId"}}`, encodeURIComponent(String(requestParameters['v3StudentPStudentId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetV3StudentPracticeSummaryR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * getV3StudentPracticeSummaryR
     */
    getV3StudentPracticeSummaryR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getV3StudentPracticeSummaryRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * getV3StudentsPresenceEventsR
     */
    getV3StudentsPresenceEventsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/presence-events`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetV3StudentsPresenceEventsR200ResponseInnerFromJSON));
        });
    }
    /**
     * getV3StudentsPresenceEventsR
     */
    getV3StudentsPresenceEventsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getV3StudentsPresenceEventsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * getV3TeachersR
     */
    getV3TeachersRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/teachers`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetV3TeachersR200ResponseInnerFromJSON));
        });
    }
    /**
     * getV3TeachersR
     */
    getV3TeachersR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getV3TeachersRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchConnectionCheckR
     */
    patchConnectionCheckRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/connection-check`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchConnectionCheckR
     */
    patchConnectionCheckR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchConnectionCheckRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchContentAreaStandardSetsR
     */
    patchContentAreaStandardSetsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling patchContentAreaStandardSetsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/standard-sets`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchContentAreaStandardSetsR
     */
    patchContentAreaStandardSetsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchContentAreaStandardSetsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchCourseR
     */
    patchCourseRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseRCourseId'] == null) {
                throw new runtime.RequiredError('courseRCourseId', 'Required parameter "courseRCourseId" was null or undefined when calling patchCourseR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseR-CourseId}`.replace(`{${"CourseR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseRCourseId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCoursesR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchCourseR
     */
    patchCourseR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchCourseRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchCourseStudentSubjectEnabledDashboardModesR
     */
    patchCourseStudentSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseStudentSubjectEnabledDashboardModesRCourseId'] == null) {
                throw new runtime.RequiredError('courseStudentSubjectEnabledDashboardModesRCourseId', 'Required parameter "courseStudentSubjectEnabledDashboardModesRCourseId" was null or undefined when calling patchCourseStudentSubjectEnabledDashboardModesR().');
            }
            if (requestParameters['courseStudentSubjectEnabledDashboardModesRStudentId'] == null) {
                throw new runtime.RequiredError('courseStudentSubjectEnabledDashboardModesRStudentId', 'Required parameter "courseStudentSubjectEnabledDashboardModesRStudentId" was null or undefined when calling patchCourseStudentSubjectEnabledDashboardModesR().');
            }
            if (requestParameters['courseStudentSubjectEnabledDashboardModesRSubject'] == null) {
                throw new runtime.RequiredError('courseStudentSubjectEnabledDashboardModesRSubject', 'Required parameter "courseStudentSubjectEnabledDashboardModesRSubject" was null or undefined when calling patchCourseStudentSubjectEnabledDashboardModesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseStudentSubjectEnabledDashboardModesR-CourseId}/students/{CourseStudentSubjectEnabledDashboardModesR-StudentId}/subjects/{CourseStudentSubjectEnabledDashboardModesR-Subject}/enabled-practice-modes`.replace(`{${"CourseStudentSubjectEnabledDashboardModesR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseStudentSubjectEnabledDashboardModesRCourseId']))).replace(`{${"CourseStudentSubjectEnabledDashboardModesR-StudentId"}}`, encodeURIComponent(String(requestParameters['courseStudentSubjectEnabledDashboardModesRStudentId']))).replace(`{${"CourseStudentSubjectEnabledDashboardModesR-Subject"}}`, encodeURIComponent(String(requestParameters['courseStudentSubjectEnabledDashboardModesRSubject']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetCourseEnabledDashboardModesR200ResponseInnerFromJSON));
        });
    }
    /**
     * patchCourseStudentSubjectEnabledDashboardModesR
     */
    patchCourseStudentSubjectEnabledDashboardModesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchCourseStudentSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchCourseSubjectEnabledDashboardModesR
     */
    patchCourseSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseSubjectEnabledDashboardModesRCourseId'] == null) {
                throw new runtime.RequiredError('courseSubjectEnabledDashboardModesRCourseId', 'Required parameter "courseSubjectEnabledDashboardModesRCourseId" was null or undefined when calling patchCourseSubjectEnabledDashboardModesR().');
            }
            if (requestParameters['courseSubjectEnabledDashboardModesRSubject'] == null) {
                throw new runtime.RequiredError('courseSubjectEnabledDashboardModesRSubject', 'Required parameter "courseSubjectEnabledDashboardModesRSubject" was null or undefined when calling patchCourseSubjectEnabledDashboardModesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseSubjectEnabledDashboardModesR-CourseId}/subjects/{CourseSubjectEnabledDashboardModesR-Subject}/enabled-practice-modes`.replace(`{${"CourseSubjectEnabledDashboardModesR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseSubjectEnabledDashboardModesRCourseId']))).replace(`{${"CourseSubjectEnabledDashboardModesR-Subject"}}`, encodeURIComponent(String(requestParameters['courseSubjectEnabledDashboardModesRSubject']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchCourseSubjectEnabledDashboardModesR
     */
    patchCourseSubjectEnabledDashboardModesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchCourseSubjectEnabledDashboardModesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchCourseSubjectProductSettingsR
     */
    patchCourseSubjectProductSettingsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling patchCourseSubjectProductSettingsR().');
            }
            if (requestParameters['courseSubjectPSubject'] == null) {
                throw new runtime.RequiredError('courseSubjectPSubject', 'Required parameter "courseSubjectPSubject" was null or undefined when calling patchCourseSubjectProductSettingsR().');
            }
            if (requestParameters['courseProductPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('courseProductPAbbreviatedProduct', 'Required parameter "courseProductPAbbreviatedProduct" was null or undefined when calling patchCourseSubjectProductSettingsR().');
            }
            if (requestParameters['courseSubjectProductSettingsRStudentId'] == null) {
                throw new runtime.RequiredError('courseSubjectProductSettingsRStudentId', 'Required parameter "courseSubjectProductSettingsRStudentId" was null or undefined when calling patchCourseSubjectProductSettingsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/subjects/{CourseSubjectP-Subject}/products/{CourseProductP-AbbreviatedProduct}/settings/{CourseSubjectProductSettingsR-StudentId}`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))).replace(`{${"CourseSubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['courseSubjectPSubject']))).replace(`{${"CourseProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['courseProductPAbbreviatedProduct']))).replace(`{${"CourseSubjectProductSettingsR-StudentId"}}`, encodeURIComponent(String(requestParameters['courseSubjectProductSettingsRStudentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchCourseSubjectProductSettingsR
     */
    patchCourseSubjectProductSettingsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchCourseSubjectProductSettingsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchCoursesStudentsR
     */
    patchCoursesStudentsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesStudentsRCourseId'] == null) {
                throw new runtime.RequiredError('coursesStudentsRCourseId', 'Required parameter "coursesStudentsRCourseId" was null or undefined when calling patchCoursesStudentsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesStudentsR-CourseId}/students`.replace(`{${"CoursesStudentsR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesStudentsRCourseId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchCoursesStudentsR
     */
    patchCoursesStudentsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchCoursesStudentsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchDistrictR
     */
    patchDistrictRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling patchDistrictR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetDistrictsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchDistrictR
     */
    patchDistrictR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchDistrictRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaAdaptiveSkillsAnswersR
     */
    patchElaAdaptiveSkillsAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAdaptiveSkillsAnswersRElaAdaptiveSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaAdaptiveSkillsAnswersRElaAdaptiveSkillsPracticeAssignmentId', 'Required parameter "elaAdaptiveSkillsAnswersRElaAdaptiveSkillsPracticeAssignmentId" was null or undefined when calling patchElaAdaptiveSkillsAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/adaptive-skills/{ElaAdaptiveSkillsAnswersR-ElaAdaptiveSkillsPracticeAssignmentId}/answers`.replace(`{${"ElaAdaptiveSkillsAnswersR-ElaAdaptiveSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaAdaptiveSkillsAnswersRElaAdaptiveSkillsPracticeAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchElaAdaptiveSkillsAnswersR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * patchElaAdaptiveSkillsAnswersR
     */
    patchElaAdaptiveSkillsAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaAdaptiveSkillsAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaAdaptiveSkillsAssignmentSessionR
     */
    patchElaAdaptiveSkillsAssignmentSessionRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAdaptiveSkillsAssignmentSessionRElaAdaptiveSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaAdaptiveSkillsAssignmentSessionRElaAdaptiveSkillsPracticeAssignmentId', 'Required parameter "elaAdaptiveSkillsAssignmentSessionRElaAdaptiveSkillsPracticeAssignmentId" was null or undefined when calling patchElaAdaptiveSkillsAssignmentSessionR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/adaptive-skills/{ElaAdaptiveSkillsAssignmentSessionR-ElaAdaptiveSkillsPracticeAssignmentId}/session`.replace(`{${"ElaAdaptiveSkillsAssignmentSessionR-ElaAdaptiveSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaAdaptiveSkillsAssignmentSessionRElaAdaptiveSkillsPracticeAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchElaAdaptiveSkillsAssignmentSessionR
     */
    patchElaAdaptiveSkillsAssignmentSessionR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaAdaptiveSkillsAssignmentSessionRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaArticleReadingAssignmentSessionsR
     */
    patchElaArticleReadingAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId', 'Required parameter "elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId" was null or undefined when calling patchElaArticleReadingAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/reading/{ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId}/sessions`.replace(`{${"ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchElaArticleReadingAssignmentSessionsR
     */
    patchElaArticleReadingAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaArticleReadingAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaArticleWritingAnswerR
     */
    patchElaArticleWritingAnswerRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleWritingAnswerRElaArticleWritingAnswerId'] == null) {
                throw new runtime.RequiredError('elaArticleWritingAnswerRElaArticleWritingAnswerId', 'Required parameter "elaArticleWritingAnswerRElaArticleWritingAnswerId" was null or undefined when calling patchElaArticleWritingAnswerR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignment-answers/writing/{ElaArticleWritingAnswerR-ElaArticleWritingAnswerId}`.replace(`{${"ElaArticleWritingAnswerR-ElaArticleWritingAnswerId"}}`, encodeURIComponent(String(requestParameters['elaArticleWritingAnswerRElaArticleWritingAnswerId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetElaArticleWritingAnswersR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchElaArticleWritingAnswerR
     */
    patchElaArticleWritingAnswerR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaArticleWritingAnswerRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaArticleWritingAssignmentSessionsR
     */
    patchElaArticleWritingAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId', 'Required parameter "elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId" was null or undefined when calling patchElaArticleWritingAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/writing/{ElaArticleWritingAssignmentP-NonEmptyElaArticleWritingAssignmentId}/sessions`.replace(`{${"ElaArticleWritingAssignmentP-NonEmptyElaArticleWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchElaArticleWritingAssignmentSessionsR
     */
    patchElaArticleWritingAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaArticleWritingAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaAssessmentAssignmentSessionsR
     */
    patchElaAssessmentAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId'] == null) {
                throw new runtime.RequiredError('elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId', 'Required parameter "elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId" was null or undefined when calling patchElaAssessmentAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/assessments/{ElaAssessmentAssignmentP-NonEmptyElaAssessmentAssignmentId}/sessions`.replace(`{${"ElaAssessmentAssignmentP-NonEmptyElaAssessmentAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchElaAssessmentAssignmentSessionsR
     */
    patchElaAssessmentAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaAssessmentAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaDecodablesAssignmentSessionsR
     */
    patchElaDecodablesAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaDecodablesAssignmentPNonEmptyElaDecodablesAssignmentId'] == null) {
                throw new runtime.RequiredError('elaDecodablesAssignmentPNonEmptyElaDecodablesAssignmentId', 'Required parameter "elaDecodablesAssignmentPNonEmptyElaDecodablesAssignmentId" was null or undefined when calling patchElaDecodablesAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/decodables/{ElaDecodablesAssignmentP-NonEmptyElaDecodablesAssignmentId}/sessions`.replace(`{${"ElaDecodablesAssignmentP-NonEmptyElaDecodablesAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaDecodablesAssignmentPNonEmptyElaDecodablesAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchElaDecodablesAssignmentSessionsR
     */
    patchElaDecodablesAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaDecodablesAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaTargetedSkillsAnswersR
     */
    patchElaTargetedSkillsAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId', 'Required parameter "elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId" was null or undefined when calling patchElaTargetedSkillsAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/targeted-skills/{ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId}/answers`.replace(`{${"ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchElaAdaptiveSkillsAnswersR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * patchElaTargetedSkillsAnswersR
     */
    patchElaTargetedSkillsAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaTargetedSkillsAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaTargetedSkillsAssignmentSessionsR
     */
    patchElaTargetedSkillsAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId', 'Required parameter "elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId" was null or undefined when calling patchElaTargetedSkillsAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/targeted-skills/{ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId}/sessions`.replace(`{${"ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchElaTargetedSkillsAssignmentSessionsR
     */
    patchElaTargetedSkillsAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaTargetedSkillsAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchElaWordStudyAssignmentSessionsR
     */
    patchElaWordStudyAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaWordStudyAssignmentPNonEmptyWordStudyAssignmentId'] == null) {
                throw new runtime.RequiredError('elaWordStudyAssignmentPNonEmptyWordStudyAssignmentId', 'Required parameter "elaWordStudyAssignmentPNonEmptyWordStudyAssignmentId" was null or undefined when calling patchElaWordStudyAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/word-study/{ElaWordStudyAssignmentP-NonEmptyWordStudyAssignmentId}/sessions`.replace(`{${"ElaWordStudyAssignmentP-NonEmptyWordStudyAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaWordStudyAssignmentPNonEmptyWordStudyAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchElaWordStudyAssignmentSessionsR
     */
    patchElaWordStudyAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchElaWordStudyAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchItemOwnershipsR
     */
    patchItemOwnershipsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/item-ownerships`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchItemOwnershipsR
     */
    patchItemOwnershipsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchItemOwnershipsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchItemR
     */
    patchItemRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['itemPItemId'] == null) {
                throw new runtime.RequiredError('itemPItemId', 'Required parameter "itemPItemId" was null or undefined when calling patchItemR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/items/{ItemP-ItemId}`.replace(`{${"ItemP-ItemId"}}`, encodeURIComponent(String(requestParameters['itemPItemId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchItemR
     */
    patchItemR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchItemRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchMathAdaptiveAssignmentSessionsR
     */
    patchMathAdaptiveAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathAdaptiveAssignmentPNonEmptyMathAdaptiveAssignmentId'] == null) {
                throw new runtime.RequiredError('mathAdaptiveAssignmentPNonEmptyMathAdaptiveAssignmentId', 'Required parameter "mathAdaptiveAssignmentPNonEmptyMathAdaptiveAssignmentId" was null or undefined when calling patchMathAdaptiveAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assignments/adaptive/{MathAdaptiveAssignmentP-NonEmptyMathAdaptiveAssignmentId}/assignment-sessions`.replace(`{${"MathAdaptiveAssignmentP-NonEmptyMathAdaptiveAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathAdaptiveAssignmentPNonEmptyMathAdaptiveAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchMathAdaptiveAssignmentSessionsR
     */
    patchMathAdaptiveAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchMathAdaptiveAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchMathAssessmentAssignmentSessionsR
     */
    patchMathAssessmentAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathAssessmentAssignmentsPNonEmptyMathAssessmentAssignmentId'] == null) {
                throw new runtime.RequiredError('mathAssessmentAssignmentsPNonEmptyMathAssessmentAssignmentId', 'Required parameter "mathAssessmentAssignmentsPNonEmptyMathAssessmentAssignmentId" was null or undefined when calling patchMathAssessmentAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assignments/assessment/{MathAssessmentAssignmentsP-NonEmptyMathAssessmentAssignmentId}/assignment-sessions`.replace(`{${"MathAssessmentAssignmentsP-NonEmptyMathAssessmentAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathAssessmentAssignmentsPNonEmptyMathAssessmentAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchMathAssessmentAssignmentSessionsR
     */
    patchMathAssessmentAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchMathAssessmentAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchMathAssessmentsAssessmentAnswerR
     */
    patchMathAssessmentsAssessmentAnswerRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathAssessmentsAssessmentAnswerRMathAssessmentAssignmentId'] == null) {
                throw new runtime.RequiredError('mathAssessmentsAssessmentAnswerRMathAssessmentAssignmentId', 'Required parameter "mathAssessmentsAssessmentAnswerRMathAssessmentAssignmentId" was null or undefined when calling patchMathAssessmentsAssessmentAnswerR().');
            }
            if (requestParameters['mathAssessmentsAssessmentAnswerRAssessmentAnswerId'] == null) {
                throw new runtime.RequiredError('mathAssessmentsAssessmentAnswerRAssessmentAnswerId', 'Required parameter "mathAssessmentsAssessmentAnswerRAssessmentAnswerId" was null or undefined when calling patchMathAssessmentsAssessmentAnswerR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assessments/{MathAssessmentsAssessmentAnswerR-MathAssessmentAssignmentId}/assessment-answers/{MathAssessmentsAssessmentAnswerR-AssessmentAnswerId}`.replace(`{${"MathAssessmentsAssessmentAnswerR-MathAssessmentAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathAssessmentsAssessmentAnswerRMathAssessmentAssignmentId']))).replace(`{${"MathAssessmentsAssessmentAnswerR-AssessmentAnswerId"}}`, encodeURIComponent(String(requestParameters['mathAssessmentsAssessmentAnswerRAssessmentAnswerId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetMathAssessmentsAssessmentAnswersR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchMathAssessmentsAssessmentAnswerR
     */
    patchMathAssessmentsAssessmentAnswerR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchMathAssessmentsAssessmentAnswerRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchMathFactPracticeAssignmentSessionsR
     */
    patchMathFactPracticeAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathFactPracticeAssignmentsPNonEmptyMathFactPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('mathFactPracticeAssignmentsPNonEmptyMathFactPracticeAssignmentId', 'Required parameter "mathFactPracticeAssignmentsPNonEmptyMathFactPracticeAssignmentId" was null or undefined when calling patchMathFactPracticeAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assignments/fact-practice/{MathFactPracticeAssignmentsP-NonEmptyMathFactPracticeAssignmentId}/assignment-sessions`.replace(`{${"MathFactPracticeAssignmentsP-NonEmptyMathFactPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathFactPracticeAssignmentsPNonEmptyMathFactPracticeAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchMathFactPracticeAssignmentSessionsR
     */
    patchMathFactPracticeAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchMathFactPracticeAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchMathIblAssignmentSessionsR
     */
    patchMathIblAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathIblAssignmentsPNonEmptyMathIblAssignmentId'] == null) {
                throw new runtime.RequiredError('mathIblAssignmentsPNonEmptyMathIblAssignmentId', 'Required parameter "mathIblAssignmentsPNonEmptyMathIblAssignmentId" was null or undefined when calling patchMathIblAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assignments/ibl/{MathIblAssignmentsP-NonEmptyMathIblAssignmentId}/assignment-sessions`.replace(`{${"MathIblAssignmentsP-NonEmptyMathIblAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathIblAssignmentsPNonEmptyMathIblAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchMathIblAssignmentSessionsR
     */
    patchMathIblAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchMathIblAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchMathStandardAssignmentSessionsR
     */
    patchMathStandardAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['mathStandardAssignmentsPNonEmptyMathStandardAssignmentId'] == null) {
                throw new runtime.RequiredError('mathStandardAssignmentsPNonEmptyMathStandardAssignmentId', 'Required parameter "mathStandardAssignmentsPNonEmptyMathStandardAssignmentId" was null or undefined when calling patchMathStandardAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assignments/standard/{MathStandardAssignmentsP-NonEmptyMathStandardAssignmentId}/assignment-sessions`.replace(`{${"MathStandardAssignmentsP-NonEmptyMathStandardAssignmentId"}}`, encodeURIComponent(String(requestParameters['mathStandardAssignmentsPNonEmptyMathStandardAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchMathStandardAssignmentSessionsR
     */
    patchMathStandardAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchMathStandardAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchNumberFactsAssignmentSessionsR
     */
    patchNumberFactsAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['numberFactsAssignmentsPNonEmptyNumberFactsAssignmentId'] == null) {
                throw new runtime.RequiredError('numberFactsAssignmentsPNonEmptyNumberFactsAssignmentId', 'Required parameter "numberFactsAssignmentsPNonEmptyNumberFactsAssignmentId" was null or undefined when calling patchNumberFactsAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math/number-facts/assignments/{NumberFactsAssignmentsP-NonEmptyNumberFactsAssignmentId}/sessions`.replace(`{${"NumberFactsAssignmentsP-NonEmptyNumberFactsAssignmentId"}}`, encodeURIComponent(String(requestParameters['numberFactsAssignmentsPNonEmptyNumberFactsAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchNumberFactsAssignmentSessionsR
     */
    patchNumberFactsAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchNumberFactsAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchRostersR
     */
    patchRostersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling patchRostersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/rosters`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatchRostersR200ResponseInnerFromJSON));
        });
    }
    /**
     * patchRostersR
     */
    patchRostersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchRostersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSchoolAdminCredentialsR
     */
    patchSchoolAdminCredentialsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolAdminPSchoolAdminId'] == null) {
                throw new runtime.RequiredError('schoolAdminPSchoolAdminId', 'Required parameter "schoolAdminPSchoolAdminId" was null or undefined when calling patchSchoolAdminCredentialsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/{SchoolAdminP-SchoolAdminId}/credentials`.replace(`{${"SchoolAdminP-SchoolAdminId"}}`, encodeURIComponent(String(requestParameters['schoolAdminPSchoolAdminId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchSchoolAdminCredentialsR
     */
    patchSchoolAdminCredentialsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSchoolAdminCredentialsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSchoolAdminR
     */
    patchSchoolAdminRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolAdminPSchoolAdminId'] == null) {
                throw new runtime.RequiredError('schoolAdminPSchoolAdminId', 'Required parameter "schoolAdminPSchoolAdminId" was null or undefined when calling patchSchoolAdminR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/{SchoolAdminP-SchoolAdminId}`.replace(`{${"SchoolAdminP-SchoolAdminId"}}`, encodeURIComponent(String(requestParameters['schoolAdminPSchoolAdminId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolAdminsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchSchoolAdminR
     */
    patchSchoolAdminR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSchoolAdminRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSchoolAdminRostersR
     */
    patchSchoolAdminRostersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolAdminPSchoolAdminId'] == null) {
                throw new runtime.RequiredError('schoolAdminPSchoolAdminId', 'Required parameter "schoolAdminPSchoolAdminId" was null or undefined when calling patchSchoolAdminRostersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/{SchoolAdminP-SchoolAdminId}/rosters`.replace(`{${"SchoolAdminP-SchoolAdminId"}}`, encodeURIComponent(String(requestParameters['schoolAdminPSchoolAdminId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatchRostersR200ResponseInnerFromJSON));
        });
    }
    /**
     * patchSchoolAdminRostersR
     */
    patchSchoolAdminRostersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSchoolAdminRostersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSchoolAdminsMeR
     */
    patchSchoolAdminsMeRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/me`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolAdminsMeR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * patchSchoolAdminsMeR
     */
    patchSchoolAdminsMeR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSchoolAdminsMeRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSchoolR
     */
    patchSchoolRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling patchSchoolR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchSchoolR
     */
    patchSchoolR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSchoolRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchScienceReadingAssignmentSessionsR
     */
    patchScienceReadingAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId', 'Required parameter "scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId" was null or undefined when calling patchScienceReadingAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/reading/{ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId}/sessions`.replace(`{${"ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchScienceReadingAssignmentSessionsR
     */
    patchScienceReadingAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchScienceReadingAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchScienceWritingAssignmentAnswerR
     */
    patchScienceWritingAssignmentAnswerRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceWritingAssignmentAnswerRScienceWritingAssignmentAnswerId'] == null) {
                throw new runtime.RequiredError('scienceWritingAssignmentAnswerRScienceWritingAssignmentAnswerId', 'Required parameter "scienceWritingAssignmentAnswerRScienceWritingAssignmentAnswerId" was null or undefined when calling patchScienceWritingAssignmentAnswerR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-writing-assignments-answers/{ScienceWritingAssignmentAnswerR-ScienceWritingAssignmentAnswerId}`.replace(`{${"ScienceWritingAssignmentAnswerR-ScienceWritingAssignmentAnswerId"}}`, encodeURIComponent(String(requestParameters['scienceWritingAssignmentAnswerRScienceWritingAssignmentAnswerId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSocialStudiesWritingAssignmentAnswersR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchScienceWritingAssignmentAnswerR
     */
    patchScienceWritingAssignmentAnswerR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchScienceWritingAssignmentAnswerRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchScienceWritingAssignmentSessionsR
     */
    patchScienceWritingAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId', 'Required parameter "scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId" was null or undefined when calling patchScienceWritingAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/writing/{ScienceWritingAssignmentP-NonEmptyScienceWritingAssignmentId}/sessions`.replace(`{${"ScienceWritingAssignmentP-NonEmptyScienceWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchScienceWritingAssignmentSessionsR
     */
    patchScienceWritingAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchScienceWritingAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSocialStudiesReadingAssignmentSessionsR
     */
    patchSocialStudiesReadingAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId', 'Required parameter "socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId" was null or undefined when calling patchSocialStudiesReadingAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/reading/{SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId}/sessions`.replace(`{${"SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchSocialStudiesReadingAssignmentSessionsR
     */
    patchSocialStudiesReadingAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSocialStudiesReadingAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSocialStudiesWritingAssignmentAnswerR
     */
    patchSocialStudiesWritingAssignmentAnswerRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesWritingAssignmentAnswerRSocialStudiesWritingAssignmentAnswerId'] == null) {
                throw new runtime.RequiredError('socialStudiesWritingAssignmentAnswerRSocialStudiesWritingAssignmentAnswerId', 'Required parameter "socialStudiesWritingAssignmentAnswerRSocialStudiesWritingAssignmentAnswerId" was null or undefined when calling patchSocialStudiesWritingAssignmentAnswerR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-writing-assignments-answers/{SocialStudiesWritingAssignmentAnswerR-SocialStudiesWritingAssignmentAnswerId}`.replace(`{${"SocialStudiesWritingAssignmentAnswerR-SocialStudiesWritingAssignmentAnswerId"}}`, encodeURIComponent(String(requestParameters['socialStudiesWritingAssignmentAnswerRSocialStudiesWritingAssignmentAnswerId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSocialStudiesWritingAssignmentAnswersR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchSocialStudiesWritingAssignmentAnswerR
     */
    patchSocialStudiesWritingAssignmentAnswerR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSocialStudiesWritingAssignmentAnswerRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSocialStudiesWritingAssignmentSessionsR
     */
    patchSocialStudiesWritingAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId', 'Required parameter "socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId" was null or undefined when calling patchSocialStudiesWritingAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/writing/{SocialStudiesWritingAssignmentP-NonEmptySocialStudiesWritingAssignmentId}/sessions`.replace(`{${"SocialStudiesWritingAssignmentP-NonEmptySocialStudiesWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchSocialStudiesWritingAssignmentSessionsR
     */
    patchSocialStudiesWritingAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSocialStudiesWritingAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchStudentPlacementsMathR
     */
    patchStudentPlacementsMathRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentPlacementsPStudentId'] == null) {
                throw new runtime.RequiredError('studentPlacementsPStudentId', 'Required parameter "studentPlacementsPStudentId" was null or undefined when calling patchStudentPlacementsMathR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentPlacementsP-StudentId}/placements/math`.replace(`{${"StudentPlacementsP-StudentId"}}`, encodeURIComponent(String(requestParameters['studentPlacementsPStudentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchStudentPlacementsMathR
     */
    patchStudentPlacementsMathR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchStudentPlacementsMathRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchStudentR
     */
    patchStudentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentRStudentId'] == null) {
                throw new runtime.RequiredError('studentRStudentId', 'Required parameter "studentRStudentId" was null or undefined when calling patchStudentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentR-StudentId}`.replace(`{${"StudentR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentRStudentId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchStudentR
     */
    patchStudentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchStudentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchStudentsGoalR
     */
    patchStudentsGoalRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['goalsPStudentId'] == null) {
                throw new runtime.RequiredError('goalsPStudentId', 'Required parameter "goalsPStudentId" was null or undefined when calling patchStudentsGoalR().');
            }
            if (requestParameters['goalPStudentGoalId'] == null) {
                throw new runtime.RequiredError('goalPStudentGoalId', 'Required parameter "goalPStudentGoalId" was null or undefined when calling patchStudentsGoalR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{GoalsP-StudentId}/goals/{GoalP-StudentGoalId}`.replace(`{${"GoalsP-StudentId"}}`, encodeURIComponent(String(requestParameters['goalsPStudentId']))).replace(`{${"GoalP-StudentGoalId"}}`, encodeURIComponent(String(requestParameters['goalPStudentGoalId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchStudentsGoalR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * patchStudentsGoalR
     */
    patchStudentsGoalR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchStudentsGoalRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSubjectProductAssignmentR
     */
    patchSubjectProductAssignmentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling patchSubjectProductAssignmentR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling patchSubjectProductAssignmentR().');
            }
            if (requestParameters['subjectProductAssignmentPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductAssignmentPInt64', 'Required parameter "subjectProductAssignmentPInt64" was null or undefined when calling patchSubjectProductAssignmentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/assignments/{SubjectProductAssignmentP-Int64}`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductAssignmentP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductAssignmentPInt64']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchSubjectProductAssignmentR
     */
    patchSubjectProductAssignmentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSubjectProductAssignmentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSubjectProductAssignmentSessionsR
     */
    patchSubjectProductAssignmentSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling patchSubjectProductAssignmentSessionsR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling patchSubjectProductAssignmentSessionsR().');
            }
            if (requestParameters['subjectProductAssignmentPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductAssignmentPInt64', 'Required parameter "subjectProductAssignmentPInt64" was null or undefined when calling patchSubjectProductAssignmentSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/assignments/{SubjectProductAssignmentP-Int64}/sessions`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductAssignmentP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductAssignmentPInt64']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * patchSubjectProductAssignmentSessionsR
     */
    patchSubjectProductAssignmentSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSubjectProductAssignmentSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchSubjectProductSessionR
     */
    patchSubjectProductSessionRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling patchSubjectProductSessionR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling patchSubjectProductSessionR().');
            }
            if (requestParameters['subjectProductSessionPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductSessionPInt64', 'Required parameter "subjectProductSessionPInt64" was null or undefined when calling patchSubjectProductSessionR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions/{SubjectProductSessionP-Int64}`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductSessionP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionPInt64']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSubjectProductSessionsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * patchSubjectProductSessionR
     */
    patchSubjectProductSessionR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchSubjectProductSessionRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * patchTeacherR
     */
    patchTeacherRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teacherRTeacherId'] == null) {
                throw new runtime.RequiredError('teacherRTeacherId', 'Required parameter "teacherRTeacherId" was null or undefined when calling patchTeacherR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeacherR-TeacherId}`.replace(`{${"TeacherR-TeacherId"}}`, encodeURIComponent(String(requestParameters['teacherRTeacherId']))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetTeachersMeR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * patchTeacherR
     */
    patchTeacherR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.patchTeacherRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postAdminsImpersonationsR
     */
    postAdminsImpersonationsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/admins/impersonations`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postAdminsImpersonationsR
     */
    postAdminsImpersonationsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postAdminsImpersonationsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postConsoleImpersonationsR
     */
    postConsoleImpersonationsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/console/impersonations`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postConsoleImpersonationsR
     */
    postConsoleImpersonationsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postConsoleImpersonationsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postConsoleJobsR
     */
    postConsoleJobsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/console/jobs`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postConsoleJobsR
     */
    postConsoleJobsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postConsoleJobsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postContentAreaAdaptiveQuestionsArbitraryR
     */
    postContentAreaAdaptiveQuestionsArbitraryRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling postContentAreaAdaptiveQuestionsArbitraryR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/adaptive/questions/arbitrary`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostContentAreaAdaptiveQuestionsArbitraryR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postContentAreaAdaptiveQuestionsArbitraryR
     */
    postContentAreaAdaptiveQuestionsArbitraryR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postContentAreaAdaptiveQuestionsArbitraryRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postContentAreaAssessmentQuestionsArbitraryR
     */
    postContentAreaAssessmentQuestionsArbitraryRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling postContentAreaAssessmentQuestionsArbitraryR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/assessments/questions/arbitrary`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostContentAreaAdaptiveQuestionsArbitraryR200ResponseFromJSON));
        });
    }
    /**
     * postContentAreaAssessmentQuestionsArbitraryR
     */
    postContentAreaAssessmentQuestionsArbitraryR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postContentAreaAssessmentQuestionsArbitraryRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postContentAreaDiagnosticQuestionsArbitraryR
     */
    postContentAreaDiagnosticQuestionsArbitraryRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling postContentAreaDiagnosticQuestionsArbitraryR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/diagnostic/questions/arbitrary`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostContentAreaAdaptiveQuestionsArbitraryR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postContentAreaDiagnosticQuestionsArbitraryR
     */
    postContentAreaDiagnosticQuestionsArbitraryR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postContentAreaDiagnosticQuestionsArbitraryRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postContentAreaDomainsExclusionsR
     */
    postContentAreaDomainsExclusionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling postContentAreaDomainsExclusionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/domains/exclusions`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postContentAreaDomainsExclusionsR
     */
    postContentAreaDomainsExclusionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postContentAreaDomainsExclusionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postContentAreaQuestionsArbitraryR
     */
    postContentAreaQuestionsArbitraryRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('contentAreaPContentArea', 'Required parameter "contentAreaPContentArea" was null or undefined when calling postContentAreaQuestionsArbitraryR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/{ContentAreaP-ContentArea}/questions/arbitrary`.replace(`{${"ContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['contentAreaPContentArea']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostContentAreaQuestionsArbitraryR200ResponseInnerFromJSON));
        });
    }
    /**
     * postContentAreaQuestionsArbitraryR
     */
    postContentAreaQuestionsArbitraryR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postContentAreaQuestionsArbitraryRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postContentFeedbackR
     */
    postContentFeedbackRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/content-feedback`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postContentFeedbackR
     */
    postContentFeedbackR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postContentFeedbackRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postCourseSubjectProductPrintableAssignmentsR
     */
    postCourseSubjectProductPrintableAssignmentsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3CoursePCourseId'] == null) {
                throw new runtime.RequiredError('v3CoursePCourseId', 'Required parameter "v3CoursePCourseId" was null or undefined when calling postCourseSubjectProductPrintableAssignmentsR().');
            }
            if (requestParameters['courseSubjectPSubject'] == null) {
                throw new runtime.RequiredError('courseSubjectPSubject', 'Required parameter "courseSubjectPSubject" was null or undefined when calling postCourseSubjectProductPrintableAssignmentsR().');
            }
            if (requestParameters['courseProductPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('courseProductPAbbreviatedProduct', 'Required parameter "courseProductPAbbreviatedProduct" was null or undefined when calling postCourseSubjectProductPrintableAssignmentsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/courses/{V3CourseP-CourseId}/subjects/{CourseSubjectP-Subject}/products/{CourseProductP-AbbreviatedProduct}/printable-assignments`.replace(`{${"V3CourseP-CourseId"}}`, encodeURIComponent(String(requestParameters['v3CoursePCourseId']))).replace(`{${"CourseSubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['courseSubjectPSubject']))).replace(`{${"CourseProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['courseProductPAbbreviatedProduct']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostCourseSubjectProductPrintableAssignmentsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postCourseSubjectProductPrintableAssignmentsR
     */
    postCourseSubjectProductPrintableAssignmentsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCourseSubjectProductPrintableAssignmentsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postCourseSubjectsR
     */
    postCourseSubjectsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['courseSubjectsRCourseId'] == null) {
                throw new runtime.RequiredError('courseSubjectsRCourseId', 'Required parameter "courseSubjectsRCourseId" was null or undefined when calling postCourseSubjectsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CourseSubjectsR-CourseId}/subjects`.replace(`{${"CourseSubjectsR-CourseId"}}`, encodeURIComponent(String(requestParameters['courseSubjectsRCourseId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postCourseSubjectsR
     */
    postCourseSubjectsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCourseSubjectsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postCoursesIdpStudentMergeR
     */
    postCoursesIdpStudentMergeRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesIdpStudentMergeRCourseId'] == null) {
                throw new runtime.RequiredError('coursesIdpStudentMergeRCourseId', 'Required parameter "coursesIdpStudentMergeRCourseId" was null or undefined when calling postCoursesIdpStudentMergeR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesIdpStudentMergeR-CourseId}/idp-student-merge`.replace(`{${"CoursesIdpStudentMergeR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesIdpStudentMergeRCourseId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postCoursesIdpStudentMergeR
     */
    postCoursesIdpStudentMergeR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCoursesIdpStudentMergeRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postCoursesR
     */
    postCoursesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCoursesR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * postCoursesR
     */
    postCoursesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCoursesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postCoursesStudentsR
     */
    postCoursesStudentsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['coursesStudentsRCourseId'] == null) {
                throw new runtime.RequiredError('coursesStudentsRCourseId', 'Required parameter "coursesStudentsRCourseId" was null or undefined when calling postCoursesStudentsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/courses/{CoursesStudentsR-CourseId}/students`.replace(`{${"CoursesStudentsR-CourseId"}}`, encodeURIComponent(String(requestParameters['coursesStudentsRCourseId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsR200ResponseInnerFromJSON));
        });
    }
    /**
     * postCoursesStudentsR
     */
    postCoursesStudentsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCoursesStudentsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postDemoDistrictsR
     */
    postDemoDistrictsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/demo-districts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * postDemoDistrictsR
     */
    postDemoDistrictsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDemoDistrictsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postDistrictSchoolAdminSchoolMembershipsR
     */
    postDistrictSchoolAdminSchoolMembershipsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling postDistrictSchoolAdminSchoolMembershipsR().');
            }
            if (requestParameters['districtSchoolAdminPSchoolAdminId'] == null) {
                throw new runtime.RequiredError('districtSchoolAdminPSchoolAdminId', 'Required parameter "districtSchoolAdminPSchoolAdminId" was null or undefined when calling postDistrictSchoolAdminSchoolMembershipsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/school-admins/{DistrictSchoolAdminP-SchoolAdminId}/school-memberships`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))).replace(`{${"DistrictSchoolAdminP-SchoolAdminId"}}`, encodeURIComponent(String(requestParameters['districtSchoolAdminPSchoolAdminId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postDistrictSchoolAdminSchoolMembershipsR
     */
    postDistrictSchoolAdminSchoolMembershipsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDistrictSchoolAdminSchoolMembershipsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postDistrictStudentsPlacementsContentAreaFastBridgeR
     */
    postDistrictStudentsPlacementsContentAreaFastBridgeRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling postDistrictStudentsPlacementsContentAreaFastBridgeR().');
            }
            if (requestParameters['districtStudentsPlacementsContentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('districtStudentsPlacementsContentAreaPContentArea', 'Required parameter "districtStudentsPlacementsContentAreaPContentArea" was null or undefined when calling postDistrictStudentsPlacementsContentAreaFastBridgeR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/students/placements/{DistrictStudentsPlacementsContentAreaP-ContentArea}/fast-bridge`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))).replace(`{${"DistrictStudentsPlacementsContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['districtStudentsPlacementsContentAreaPContentArea']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postDistrictStudentsPlacementsContentAreaFastBridgeR
     */
    postDistrictStudentsPlacementsContentAreaFastBridgeR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDistrictStudentsPlacementsContentAreaFastBridgeRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postDistrictStudentsPlacementsContentAreaR
     */
    postDistrictStudentsPlacementsContentAreaRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling postDistrictStudentsPlacementsContentAreaR().');
            }
            if (requestParameters['districtStudentsPlacementsContentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('districtStudentsPlacementsContentAreaPContentArea', 'Required parameter "districtStudentsPlacementsContentAreaPContentArea" was null or undefined when calling postDistrictStudentsPlacementsContentAreaR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/students/placements/{DistrictStudentsPlacementsContentAreaP-ContentArea}`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))).replace(`{${"DistrictStudentsPlacementsContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['districtStudentsPlacementsContentAreaPContentArea']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostDistrictStudentsPlacementsContentAreaR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postDistrictStudentsPlacementsContentAreaR
     */
    postDistrictStudentsPlacementsContentAreaR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDistrictStudentsPlacementsContentAreaRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postDistrictStudentsPlacementsContentAreaReadingR
     */
    postDistrictStudentsPlacementsContentAreaReadingRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling postDistrictStudentsPlacementsContentAreaReadingR().');
            }
            if (requestParameters['districtStudentsPlacementsContentAreaPContentArea'] == null) {
                throw new runtime.RequiredError('districtStudentsPlacementsContentAreaPContentArea', 'Required parameter "districtStudentsPlacementsContentAreaPContentArea" was null or undefined when calling postDistrictStudentsPlacementsContentAreaReadingR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/students/placements/{DistrictStudentsPlacementsContentAreaP-ContentArea}/reading`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))).replace(`{${"DistrictStudentsPlacementsContentAreaP-ContentArea"}}`, encodeURIComponent(String(requestParameters['districtStudentsPlacementsContentAreaPContentArea']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostDistrictStudentsPlacementsContentAreaReadingR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postDistrictStudentsPlacementsContentAreaReadingR
     */
    postDistrictStudentsPlacementsContentAreaReadingR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDistrictStudentsPlacementsContentAreaReadingRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postDistrictsR
     */
    postDistrictsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetDistrictsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * postDistrictsR
     */
    postDistrictsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDistrictsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaAdaptiveSkillsAssignmentExitR
     */
    postElaAdaptiveSkillsAssignmentExitRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAdaptiveSkillsAssignmentExitRNonEmptyElaAdaptiveSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaAdaptiveSkillsAssignmentExitRNonEmptyElaAdaptiveSkillsPracticeAssignmentId', 'Required parameter "elaAdaptiveSkillsAssignmentExitRNonEmptyElaAdaptiveSkillsPracticeAssignmentId" was null or undefined when calling postElaAdaptiveSkillsAssignmentExitR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/adaptive-skills/{ElaAdaptiveSkillsAssignmentExitR-NonEmptyElaAdaptiveSkillsPracticeAssignmentId}/exit`.replace(`{${"ElaAdaptiveSkillsAssignmentExitR-NonEmptyElaAdaptiveSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaAdaptiveSkillsAssignmentExitRNonEmptyElaAdaptiveSkillsPracticeAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postElaAdaptiveSkillsAssignmentExitR
     */
    postElaAdaptiveSkillsAssignmentExitR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaAdaptiveSkillsAssignmentExitRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaArticleReadingAnswersR
     */
    postElaArticleReadingAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId', 'Required parameter "elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId" was null or undefined when calling postElaArticleReadingAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/reading/{ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId}/answers`.replace(`{${"ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostElaArticleReadingAnswersR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postElaArticleReadingAnswersR
     */
    postElaArticleReadingAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaArticleReadingAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaArticleReadingAnswersRetriesR
     */
    postElaArticleReadingAnswersRetriesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId', 'Required parameter "elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId" was null or undefined when calling postElaArticleReadingAnswersRetriesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/reading/{ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId}/answers/retries`.replace(`{${"ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostElaArticleReadingAnswersRetriesR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postElaArticleReadingAnswersRetriesR
     */
    postElaArticleReadingAnswersRetriesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaArticleReadingAnswersRetriesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaArticleReadingAssignmentExitR
     */
    postElaArticleReadingAssignmentExitRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId', 'Required parameter "elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId" was null or undefined when calling postElaArticleReadingAssignmentExitR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/reading/{ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId}/exit`.replace(`{${"ElaArticleReadingAssignmentP-NonEmptyElaArticleReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaArticleReadingAssignmentPNonEmptyElaArticleReadingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postElaArticleReadingAssignmentExitR
     */
    postElaArticleReadingAssignmentExitR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaArticleReadingAssignmentExitRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaArticleWritingAnswersR
     */
    postElaArticleWritingAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId', 'Required parameter "elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId" was null or undefined when calling postElaArticleWritingAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/writing/{ElaArticleWritingAssignmentP-NonEmptyElaArticleWritingAssignmentId}/answers`.replace(`{${"ElaArticleWritingAssignmentP-NonEmptyElaArticleWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaArticleWritingAssignmentPNonEmptyElaArticleWritingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchStudentsGoalR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postElaArticleWritingAnswersR
     */
    postElaArticleWritingAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaArticleWritingAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaAssessmentAssignmentAnswersR
     */
    postElaAssessmentAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId'] == null) {
                throw new runtime.RequiredError('elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId', 'Required parameter "elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId" was null or undefined when calling postElaAssessmentAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/assessments/{ElaAssessmentAssignmentP-NonEmptyElaAssessmentAssignmentId}/answers`.replace(`{${"ElaAssessmentAssignmentP-NonEmptyElaAssessmentAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaAssessmentAssignmentPNonEmptyElaAssessmentAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postElaAssessmentAssignmentAnswersR
     */
    postElaAssessmentAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaAssessmentAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaDecodablesAssignmentsAnswersR
     */
    postElaDecodablesAssignmentsAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaDecodablesAssignmentPNonEmptyElaDecodablesAssignmentId'] == null) {
                throw new runtime.RequiredError('elaDecodablesAssignmentPNonEmptyElaDecodablesAssignmentId', 'Required parameter "elaDecodablesAssignmentPNonEmptyElaDecodablesAssignmentId" was null or undefined when calling postElaDecodablesAssignmentsAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/decodables/{ElaDecodablesAssignmentP-NonEmptyElaDecodablesAssignmentId}/answers`.replace(`{${"ElaDecodablesAssignmentP-NonEmptyElaDecodablesAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaDecodablesAssignmentPNonEmptyElaDecodablesAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchElaAdaptiveSkillsAnswersR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postElaDecodablesAssignmentsAnswersR
     */
    postElaDecodablesAssignmentsAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaDecodablesAssignmentsAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaDecodablesAssignmentsR
     */
    postElaDecodablesAssignmentsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/decodables`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostElaDecodablesAssignmentsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postElaDecodablesAssignmentsR
     */
    postElaDecodablesAssignmentsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaDecodablesAssignmentsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaSightWordsSessionsR
     */
    postElaSightWordsSessionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/sight-words-sessions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostElaSightWordsSessionsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postElaSightWordsSessionsR
     */
    postElaSightWordsSessionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaSightWordsSessionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postElaTargetedSkillsAssignmentExitR
     */
    postElaTargetedSkillsAssignmentExitRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId'] == null) {
                throw new runtime.RequiredError('elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId', 'Required parameter "elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId" was null or undefined when calling postElaTargetedSkillsAssignmentExitR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ela-assignments/targeted-skills/{ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId}/exit`.replace(`{${"ElaTargetedSkillsAssignmentP-ElaTargetedSkillsPracticeAssignmentId"}}`, encodeURIComponent(String(requestParameters['elaTargetedSkillsAssignmentPElaTargetedSkillsPracticeAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postElaTargetedSkillsAssignmentExitR
     */
    postElaTargetedSkillsAssignmentExitR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postElaTargetedSkillsAssignmentExitRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postEmailVerificationsR
     */
    postEmailVerificationsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/email-verifications`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postEmailVerificationsR
     */
    postEmailVerificationsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postEmailVerificationsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postExternalDemoDistrictsR
     */
    postExternalDemoDistrictsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/demo-districts/external`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * postExternalDemoDistrictsR
     */
    postExternalDemoDistrictsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postExternalDemoDistrictsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postIblAssignmentsCompletionR
     */
    postIblAssignmentsCompletionRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['iblAssignmentsCompletionRMathIblAssignmentId'] == null) {
                throw new runtime.RequiredError('iblAssignmentsCompletionRMathIblAssignmentId', 'Required parameter "iblAssignmentsCompletionRMathIblAssignmentId" was null or undefined when calling postIblAssignmentsCompletionR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ibl-assignments/{IblAssignmentsCompletionR-MathIblAssignmentId}/completion`.replace(`{${"IblAssignmentsCompletionR-MathIblAssignmentId"}}`, encodeURIComponent(String(requestParameters['iblAssignmentsCompletionRMathIblAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postIblAssignmentsCompletionR
     */
    postIblAssignmentsCompletionR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postIblAssignmentsCompletionRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postIblSessionsR
     */
    postIblSessionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/ibl-sessions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postIblSessionsR
     */
    postIblSessionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postIblSessionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postItemsItemOwnershipR
     */
    postItemsItemOwnershipRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['itemPItemId'] == null) {
                throw new runtime.RequiredError('itemPItemId', 'Required parameter "itemPItemId" was null or undefined when calling postItemsItemOwnershipR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/items/{ItemP-ItemId}/item-ownership`.replace(`{${"ItemP-ItemId"}}`, encodeURIComponent(String(requestParameters['itemPItemId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostItemsItemOwnershipR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postItemsItemOwnershipR
     */
    postItemsItemOwnershipR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postItemsItemOwnershipRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postItemsR
     */
    postItemsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/items`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetItemsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * postItemsR
     */
    postItemsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postItemsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postMathAssignmentsR
     */
    postMathAssignmentsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math-assignments`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostElaDecodablesAssignmentsR200ResponseFromJSON));
        });
    }
    /**
     * postMathAssignmentsR
     */
    postMathAssignmentsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postMathAssignmentsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postNumberFactsSessionsR
     */
    postNumberFactsSessionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/math/number-facts/sessions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchStudentsGoalR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postNumberFactsSessionsR
     */
    postNumberFactsSessionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postNumberFactsSessionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postPasswordsR
     */
    postPasswordsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/passwords`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postPasswordsR
     */
    postPasswordsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postPasswordsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postPasswordsResetsR
     */
    postPasswordsResetsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/passwords/resets`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostPasswordsResetsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postPasswordsResetsR
     */
    postPasswordsResetsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postPasswordsResetsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postPurchasesR
     */
    postPurchasesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/purchases`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postPurchasesR
     */
    postPurchasesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postPurchasesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postRostersSisIdSyncR
     */
    postRostersSisIdSyncRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['districtPDistrictId'] == null) {
                throw new runtime.RequiredError('districtPDistrictId', 'Required parameter "districtPDistrictId" was null or undefined when calling postRostersSisIdSyncR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/districts/{DistrictP-DistrictId}/rosters/sis-id-sync`.replace(`{${"DistrictP-DistrictId"}}`, encodeURIComponent(String(requestParameters['districtPDistrictId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostRostersSisIdSyncR200ResponseInnerFromJSON));
        });
    }
    /**
     * postRostersSisIdSyncR
     */
    postRostersSisIdSyncR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postRostersSisIdSyncRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolAdminForgotPasswordR
     */
    postSchoolAdminForgotPasswordRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/forgot-password`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postSchoolAdminForgotPasswordR
     */
    postSchoolAdminForgotPasswordR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolAdminForgotPasswordRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolAdminImpressionsR
     */
    postSchoolAdminImpressionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolAdminImpressionsRSchoolAdminId'] == null) {
                throw new runtime.RequiredError('schoolAdminImpressionsRSchoolAdminId', 'Required parameter "schoolAdminImpressionsRSchoolAdminId" was null or undefined when calling postSchoolAdminImpressionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/{SchoolAdminImpressionsR-SchoolAdminId}/impression`.replace(`{${"SchoolAdminImpressionsR-SchoolAdminId"}}`, encodeURIComponent(String(requestParameters['schoolAdminImpressionsRSchoolAdminId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postSchoolAdminImpressionsR
     */
    postSchoolAdminImpressionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolAdminImpressionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolAdminsBulkUploadR
     */
    postSchoolAdminsBulkUploadRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/bulk-upload`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostSchoolAdminsBulkUploadR200ResponseInnerFromJSON));
        });
    }
    /**
     * postSchoolAdminsBulkUploadR
     */
    postSchoolAdminsBulkUploadR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolAdminsBulkUploadRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolAdminsR
     */
    postSchoolAdminsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolAdminsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * postSchoolAdminsR
     */
    postSchoolAdminsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolAdminsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolAdminsTeacherSessionsR
     */
    postSchoolAdminsTeacherSessionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/school-admins/teacher-sessions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostSchoolAdminsTeacherSessionsR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postSchoolAdminsTeacherSessionsR
     */
    postSchoolAdminsTeacherSessionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolAdminsTeacherSessionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolAssessmentsR
     */
    postSchoolAssessmentsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling postSchoolAssessmentsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/assessments`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postSchoolAssessmentsR
     */
    postSchoolAssessmentsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolAssessmentsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolIdentityProviderSyncR
     */
    postSchoolIdentityProviderSyncRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling postSchoolIdentityProviderSyncR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/identity-providers/sync`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postSchoolIdentityProviderSyncR
     */
    postSchoolIdentityProviderSyncR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolIdentityProviderSyncRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolLicensesR
     */
    postSchoolLicensesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling postSchoolLicensesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/licenses`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetSchoolLicensesR200ResponseAnyOfInner1FromJSON(jsonValue));
        });
    }
    /**
     * postSchoolLicensesR
     */
    postSchoolLicensesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolLicensesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolMergeR
     */
    postSchoolMergeRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolPSchoolId'] == null) {
                throw new runtime.RequiredError('schoolPSchoolId', 'Required parameter "schoolPSchoolId" was null or undefined when calling postSchoolMergeR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolP-SchoolId}/merge`.replace(`{${"SchoolP-SchoolId"}}`, encodeURIComponent(String(requestParameters['schoolPSchoolId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postSchoolMergeR
     */
    postSchoolMergeR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolMergeRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolProvisionR
     */
    postSchoolProvisionRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/provision`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postSchoolProvisionR
     */
    postSchoolProvisionR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolProvisionRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSchoolsSchoolAdminSchoolMembershipsR
     */
    postSchoolsSchoolAdminSchoolMembershipsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['schoolsSchoolAdminSchoolMembershipsRNonEmptySchoolId'] == null) {
                throw new runtime.RequiredError('schoolsSchoolAdminSchoolMembershipsRNonEmptySchoolId', 'Required parameter "schoolsSchoolAdminSchoolMembershipsRNonEmptySchoolId" was null or undefined when calling postSchoolsSchoolAdminSchoolMembershipsR().');
            }
            if (requestParameters['schoolsSchoolAdminSchoolMembershipsRSchoolAdminId'] == null) {
                throw new runtime.RequiredError('schoolsSchoolAdminSchoolMembershipsRSchoolAdminId', 'Required parameter "schoolsSchoolAdminSchoolMembershipsRSchoolAdminId" was null or undefined when calling postSchoolsSchoolAdminSchoolMembershipsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/schools/{SchoolsSchoolAdminSchoolMembershipsR-NonEmptySchoolId}/school-admins/{SchoolsSchoolAdminSchoolMembershipsR-SchoolAdminId}/school-memberships`.replace(`{${"SchoolsSchoolAdminSchoolMembershipsR-NonEmptySchoolId"}}`, encodeURIComponent(String(requestParameters['schoolsSchoolAdminSchoolMembershipsRNonEmptySchoolId']))).replace(`{${"SchoolsSchoolAdminSchoolMembershipsR-SchoolAdminId"}}`, encodeURIComponent(String(requestParameters['schoolsSchoolAdminSchoolMembershipsRSchoolAdminId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * postSchoolsSchoolAdminSchoolMembershipsR
     */
    postSchoolsSchoolAdminSchoolMembershipsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSchoolsSchoolAdminSchoolMembershipsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postScienceAssignmentsR
     */
    postScienceAssignmentsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostElaDecodablesAssignmentsR200ResponseFromJSON));
        });
    }
    /**
     * postScienceAssignmentsR
     */
    postScienceAssignmentsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postScienceAssignmentsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postScienceReadingAssignmentAnswersR
     */
    postScienceReadingAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId', 'Required parameter "scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId" was null or undefined when calling postScienceReadingAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/reading/{ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId}/answers`.replace(`{${"ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostElaArticleReadingAnswersR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postScienceReadingAssignmentAnswersR
     */
    postScienceReadingAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postScienceReadingAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postScienceReadingAssignmentAnswersRetriesR
     */
    postScienceReadingAssignmentAnswersRetriesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId', 'Required parameter "scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId" was null or undefined when calling postScienceReadingAssignmentAnswersRetriesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/reading/{ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId}/answers/retries`.replace(`{${"ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostElaArticleReadingAnswersRetriesR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postScienceReadingAssignmentAnswersRetriesR
     */
    postScienceReadingAssignmentAnswersRetriesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postScienceReadingAssignmentAnswersRetriesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postScienceReadingAssignmentExitR
     */
    postScienceReadingAssignmentExitRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId', 'Required parameter "scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId" was null or undefined when calling postScienceReadingAssignmentExitR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/reading/{ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId}/exit`.replace(`{${"ScienceReadingAssignmentP-NonEmptyScienceReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceReadingAssignmentPNonEmptyScienceReadingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postScienceReadingAssignmentExitR
     */
    postScienceReadingAssignmentExitR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postScienceReadingAssignmentExitRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postScienceWritingAssignmentAnswersR
     */
    postScienceWritingAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId', 'Required parameter "scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId" was null or undefined when calling postScienceWritingAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/science-assignments/writing/{ScienceWritingAssignmentP-NonEmptyScienceWritingAssignmentId}/answers`.replace(`{${"ScienceWritingAssignmentP-NonEmptyScienceWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['scienceWritingAssignmentPNonEmptyScienceWritingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchStudentsGoalR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postScienceWritingAssignmentAnswersR
     */
    postScienceWritingAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postScienceWritingAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSocialStudiesAssignmentsR
     */
    postSocialStudiesAssignmentsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PostElaDecodablesAssignmentsR200ResponseFromJSON));
        });
    }
    /**
     * postSocialStudiesAssignmentsR
     */
    postSocialStudiesAssignmentsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSocialStudiesAssignmentsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSocialStudiesReadingAssignmentAnswersR
     */
    postSocialStudiesReadingAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId', 'Required parameter "socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId" was null or undefined when calling postSocialStudiesReadingAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/reading/{SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId}/answers`.replace(`{${"SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostElaArticleReadingAnswersR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postSocialStudiesReadingAssignmentAnswersR
     */
    postSocialStudiesReadingAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSocialStudiesReadingAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSocialStudiesReadingAssignmentAnswersRetriesR
     */
    postSocialStudiesReadingAssignmentAnswersRetriesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId', 'Required parameter "socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId" was null or undefined when calling postSocialStudiesReadingAssignmentAnswersRetriesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/reading/{SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId}/answers/retries`.replace(`{${"SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostElaArticleReadingAnswersRetriesR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postSocialStudiesReadingAssignmentAnswersRetriesR
     */
    postSocialStudiesReadingAssignmentAnswersRetriesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSocialStudiesReadingAssignmentAnswersRetriesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSocialStudiesReadingAssignmentExitR
     */
    postSocialStudiesReadingAssignmentExitRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId', 'Required parameter "socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId" was null or undefined when calling postSocialStudiesReadingAssignmentExitR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/reading/{SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId}/exit`.replace(`{${"SocialStudiesReadingAssignmentP-NonEmptySocialStudiesReadingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesReadingAssignmentPNonEmptySocialStudiesReadingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postSocialStudiesReadingAssignmentExitR
     */
    postSocialStudiesReadingAssignmentExitR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSocialStudiesReadingAssignmentExitRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSocialStudiesWritingAssignmentAnswersR
     */
    postSocialStudiesWritingAssignmentAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId'] == null) {
                throw new runtime.RequiredError('socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId', 'Required parameter "socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId" was null or undefined when calling postSocialStudiesWritingAssignmentAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/social-studies-assignments/writing/{SocialStudiesWritingAssignmentP-NonEmptySocialStudiesWritingAssignmentId}/answers`.replace(`{${"SocialStudiesWritingAssignmentP-NonEmptySocialStudiesWritingAssignmentId"}}`, encodeURIComponent(String(requestParameters['socialStudiesWritingAssignmentPNonEmptySocialStudiesWritingAssignmentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchStudentsGoalR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postSocialStudiesWritingAssignmentAnswersR
     */
    postSocialStudiesWritingAssignmentAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSocialStudiesWritingAssignmentAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postStudentMathAdaptiveRewardR
     */
    postStudentMathAdaptiveRewardRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['v3StudentPStudentId'] == null) {
                throw new runtime.RequiredError('v3StudentPStudentId', 'Required parameter "v3StudentPStudentId" was null or undefined when calling postStudentMathAdaptiveRewardR().');
            }
            if (requestParameters['studentMathAdaptiveRewardRMathAdaptiveRewardId'] == null) {
                throw new runtime.RequiredError('studentMathAdaptiveRewardRMathAdaptiveRewardId', 'Required parameter "studentMathAdaptiveRewardRMathAdaptiveRewardId" was null or undefined when calling postStudentMathAdaptiveRewardR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/{V3StudentP-StudentId}/math/adaptive/rewards/{StudentMathAdaptiveRewardR-MathAdaptiveRewardId}`.replace(`{${"V3StudentP-StudentId"}}`, encodeURIComponent(String(requestParameters['v3StudentPStudentId']))).replace(`{${"StudentMathAdaptiveRewardR-MathAdaptiveRewardId"}}`, encodeURIComponent(String(requestParameters['studentMathAdaptiveRewardRMathAdaptiveRewardId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchStudentsGoalR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postStudentMathAdaptiveRewardR
     */
    postStudentMathAdaptiveRewardR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postStudentMathAdaptiveRewardRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postStudentsArchiveForCourseR
     */
    postStudentsArchiveForCourseRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentsArchiveForCourseRStudentId'] == null) {
                throw new runtime.RequiredError('studentsArchiveForCourseRStudentId', 'Required parameter "studentsArchiveForCourseRStudentId" was null or undefined when calling postStudentsArchiveForCourseR().');
            }
            if (requestParameters['studentsArchiveForCourseRCourseId'] == null) {
                throw new runtime.RequiredError('studentsArchiveForCourseRCourseId', 'Required parameter "studentsArchiveForCourseRCourseId" was null or undefined when calling postStudentsArchiveForCourseR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentsArchiveForCourseR-StudentId}/archive/{StudentsArchiveForCourseR-CourseId}`.replace(`{${"StudentsArchiveForCourseR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentsArchiveForCourseRStudentId']))).replace(`{${"StudentsArchiveForCourseR-CourseId"}}`, encodeURIComponent(String(requestParameters['studentsArchiveForCourseRCourseId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PostStudentsArchiveForCourseR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postStudentsArchiveForCourseR
     */
    postStudentsArchiveForCourseR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postStudentsArchiveForCourseRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postStudentsChangeCourseR
     */
    postStudentsChangeCourseRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['studentsChangeCourseRStudentId'] == null) {
                throw new runtime.RequiredError('studentsChangeCourseRStudentId', 'Required parameter "studentsChangeCourseRStudentId" was null or undefined when calling postStudentsChangeCourseR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{StudentsChangeCourseR-StudentId}/change-course`.replace(`{${"StudentsChangeCourseR-StudentId"}}`, encodeURIComponent(String(requestParameters['studentsChangeCourseRStudentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postStudentsChangeCourseR
     */
    postStudentsChangeCourseR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postStudentsChangeCourseRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postStudentsDuplicatesMergeR
     */
    postStudentsDuplicatesMergeRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/duplicates/merge`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postStudentsDuplicatesMergeR
     */
    postStudentsDuplicatesMergeR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postStudentsDuplicatesMergeRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postStudentsDuplicatesR
     */
    postStudentsDuplicatesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/duplicates`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetStudentsDuplicatesR200ResponseInnerFromJSON));
        });
    }
    /**
     * postStudentsDuplicatesR
     */
    postStudentsDuplicatesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postStudentsDuplicatesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postStudentsGoalsR
     */
    postStudentsGoalsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['goalsPStudentId'] == null) {
                throw new runtime.RequiredError('goalsPStudentId', 'Required parameter "goalsPStudentId" was null or undefined when calling postStudentsGoalsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/students/{GoalsP-StudentId}/goals`.replace(`{${"GoalsP-StudentId"}}`, encodeURIComponent(String(requestParameters['goalsPStudentId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postStudentsGoalsR
     */
    postStudentsGoalsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postStudentsGoalsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postStudentsIdpOverlaysR
     */
    postStudentsIdpOverlaysRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/student-idp-overlays`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postStudentsIdpOverlaysR
     */
    postStudentsIdpOverlaysR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postStudentsIdpOverlaysRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postStudentsSharesR
     */
    postStudentsSharesRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/student-shares`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postStudentsSharesR
     */
    postStudentsSharesR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postStudentsSharesRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSubjectProductSessionAnswerRetriesR
     */
    postSubjectProductSessionAnswerRetriesRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling postSubjectProductSessionAnswerRetriesR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling postSubjectProductSessionAnswerRetriesR().');
            }
            if (requestParameters['subjectProductSessionPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductSessionPInt64', 'Required parameter "subjectProductSessionPInt64" was null or undefined when calling postSubjectProductSessionAnswerRetriesR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions/{SubjectProductSessionP-Int64}/answers/retries`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductSessionP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionPInt64']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchElaAdaptiveSkillsAnswersR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postSubjectProductSessionAnswerRetriesR
     */
    postSubjectProductSessionAnswerRetriesR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSubjectProductSessionAnswerRetriesRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSubjectProductSessionAnswersR
     */
    postSubjectProductSessionAnswersRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling postSubjectProductSessionAnswersR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling postSubjectProductSessionAnswersR().');
            }
            if (requestParameters['subjectProductSessionPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductSessionPInt64', 'Required parameter "subjectProductSessionPInt64" was null or undefined when calling postSubjectProductSessionAnswersR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions/{SubjectProductSessionP-Int64}/answers`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductSessionP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionPInt64']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PatchElaAdaptiveSkillsAnswersR200ResponseFromJSON(jsonValue));
        });
    }
    /**
     * postSubjectProductSessionAnswersR
     */
    postSubjectProductSessionAnswersR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSubjectProductSessionAnswersRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postSubjectProductSessionsR
     */
    postSubjectProductSessionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling postSubjectProductSessionsR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling postSubjectProductSessionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSubjectProductSessionsR200ResponseInnerFromJSON));
        });
    }
    /**
     * postSubjectProductSessionsR
     */
    postSubjectProductSessionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postSubjectProductSessionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postTeacherImpressionsR
     */
    postTeacherImpressionsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teacherImpressionsRTeacherId'] == null) {
                throw new runtime.RequiredError('teacherImpressionsRTeacherId', 'Required parameter "teacherImpressionsRTeacherId" was null or undefined when calling postTeacherImpressionsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeacherImpressionsR-TeacherId}/impressions`.replace(`{${"TeacherImpressionsR-TeacherId"}}`, encodeURIComponent(String(requestParameters['teacherImpressionsRTeacherId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postTeacherImpressionsR
     */
    postTeacherImpressionsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postTeacherImpressionsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postTeacherInvitationR
     */
    postTeacherInvitationRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/invite`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postTeacherInvitationR
     */
    postTeacherInvitationR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postTeacherInvitationRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postTeacherLicenseAllocationsR
     */
    postTeacherLicenseAllocationsRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teacherLicenseAllocationsRTeacherId'] == null) {
                throw new runtime.RequiredError('teacherLicenseAllocationsRTeacherId', 'Required parameter "teacherLicenseAllocationsRTeacherId" was null or undefined when calling postTeacherLicenseAllocationsR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeacherLicenseAllocationsR-TeacherId}/license-allocations`.replace(`{${"TeacherLicenseAllocationsR-TeacherId"}}`, encodeURIComponent(String(requestParameters['teacherLicenseAllocationsRTeacherId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetTeacherLicenseAllocationsR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * postTeacherLicenseAllocationsR
     */
    postTeacherLicenseAllocationsR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postTeacherLicenseAllocationsRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postTeacherReminderFinishOnboardingR
     */
    postTeacherReminderFinishOnboardingRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['teacherReminderFinishOnboardingRTeacherId'] == null) {
                throw new runtime.RequiredError('teacherReminderFinishOnboardingRTeacherId', 'Required parameter "teacherReminderFinishOnboardingRTeacherId" was null or undefined when calling postTeacherReminderFinishOnboardingR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/{TeacherReminderFinishOnboardingR-TeacherId}/reminders/finish-onboarding`.replace(`{${"TeacherReminderFinishOnboardingR-TeacherId"}}`, encodeURIComponent(String(requestParameters['teacherReminderFinishOnboardingRTeacherId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postTeacherReminderFinishOnboardingR
     */
    postTeacherReminderFinishOnboardingR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postTeacherReminderFinishOnboardingRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * postTeachersAccountR
     */
    postTeachersAccountRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/accounts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetStudentsTeachersR200ResponseInnerFromJSON(jsonValue));
        });
    }
    /**
     * postTeachersAccountR
     */
    postTeachersAccountR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postTeachersAccountRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postTeachersSessionsSchoolAdminImpersonationsR
     */
    postTeachersSessionsSchoolAdminImpersonationsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/teachers/sessions/school-admin-impersonations`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postTeachersSessionsSchoolAdminImpersonationsR
     */
    postTeachersSessionsSchoolAdminImpersonationsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postTeachersSessionsSchoolAdminImpersonationsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postV3StudentImpressionsR
     */
    postV3StudentImpressionsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/impressions`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postV3StudentImpressionsR
     */
    postV3StudentImpressionsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postV3StudentImpressionsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postV3StudentsDuplicatesMergeR
     */
    postV3StudentsDuplicatesMergeRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/duplicates/merge`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postV3StudentsDuplicatesMergeR
     */
    postV3StudentsDuplicatesMergeR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postV3StudentsDuplicatesMergeRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postV3StudentsPresenceEventsR
     */
    postV3StudentsPresenceEventsRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/students/presence-events`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * postV3StudentsPresenceEventsR
     */
    postV3StudentsPresenceEventsR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postV3StudentsPresenceEventsRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * postV3WebhooksR
     */
    postV3WebhooksRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/webhooks`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * postV3WebhooksR
     */
    postV3WebhooksR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postV3WebhooksRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * putEducatorAcademyUserR
     */
    putEducatorAcademyUserRRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/2/educator-academy/user`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * putEducatorAcademyUserR
     */
    putEducatorAcademyUserR(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putEducatorAcademyUserRRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * putSubjectProductSessionSentimentR
     */
    putSubjectProductSessionSentimentRRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['subjectPSubject'] == null) {
                throw new runtime.RequiredError('subjectPSubject', 'Required parameter "subjectPSubject" was null or undefined when calling putSubjectProductSessionSentimentR().');
            }
            if (requestParameters['productPAbbreviatedProduct'] == null) {
                throw new runtime.RequiredError('productPAbbreviatedProduct', 'Required parameter "productPAbbreviatedProduct" was null or undefined when calling putSubjectProductSessionSentimentR().');
            }
            if (requestParameters['subjectProductSessionPInt64'] == null) {
                throw new runtime.RequiredError('subjectProductSessionPInt64', 'Required parameter "subjectProductSessionPInt64" was null or undefined when calling putSubjectProductSessionSentimentR().');
            }
            if (requestParameters['subjectProductSessionSentimentPSentiment'] == null) {
                throw new runtime.RequiredError('subjectProductSessionSentimentPSentiment', 'Required parameter "subjectProductSessionSentimentPSentiment" was null or undefined when calling putSubjectProductSessionSentimentR().');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/3/subjects/{SubjectP-Subject}/products/{ProductP-AbbreviatedProduct}/sessions/{SubjectProductSessionP-Int64}/sentiments/{SubjectProductSessionSentimentP-Sentiment}`.replace(`{${"SubjectP-Subject"}}`, encodeURIComponent(String(requestParameters['subjectPSubject']))).replace(`{${"ProductP-AbbreviatedProduct"}}`, encodeURIComponent(String(requestParameters['productPAbbreviatedProduct']))).replace(`{${"SubjectProductSessionP-Int64"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionPInt64']))).replace(`{${"SubjectProductSessionSentimentP-Sentiment"}}`, encodeURIComponent(String(requestParameters['subjectProductSessionSentimentPSentiment']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * putSubjectProductSessionSentimentR
     */
    putSubjectProductSessionSentimentR(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putSubjectProductSessionSentimentRRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
